<template>
  <div class="bg-light">
    <div
      :class="containerClass"
      v-if="
        !registeredSuccessfull &&
          !showPaymentDetail &&
          !registeredUnsuccessfull &&
          !showProducts &&
          !showApplication &&
          !showRefundPolicy
      "
      class="offset-lg-2 col-lg-8 col-md-12 bg-white border shadowed"
      style="
        -webkit-box-shadow: 0px 0px 19px -6px rgba(0, 0, 0, 0.75);
        -moz-box-shadow: 0px 0px 19px -6px rgba(0, 0, 0, 0.75);
        box-shadow: 0px 0px 19px -6px rgba(0, 0, 0, 0.75);
      "
    >
      <div class="d-flex justify-content-center mt-2 pt-2">
        <b-skeleton-wrapper :loading="isClassLoading">
          <template #loading>
            <b-skeleton-img width="160px" height="120px" no-aspect></b-skeleton-img>
          </template>
          <b-img :src="get(getCurrentSchool, 'logo_url')" height="110" />
        </b-skeleton-wrapper>
      </div>

      <b-skeleton-wrapper :loading="isClassLoading">
        <template #loading>
          <div class="d-flex justify-content-center mt-3">
            <b-skeleton width="60%"></b-skeleton>
          </div>
        </template>
        <div class="d-flex justify-content-center mt-2 text-center">
          <h3 class="mb-0 font-weight-bolder" v-text="`${get(classSch, 'program.title')} Registration`" />
        </div>
      </b-skeleton-wrapper>

      <div class="mx-3 mb-4 mt-4 text-center">
        <b-skeleton-wrapper :loading="isClassLoading">
          <template #loading>
            <p class="d-flex justify-content-center">
              <b-skeleton width="90%"></b-skeleton>
            </p>
          </template>

          <span style="font-size: 0.9125rem">
            <span v-if="get(getCurrentSchool, 'pp_registration_desc')">
              {{ reg_desc }}
            </span>
            <span v-else-if="get(classSch, 'program.application_fee')">
              <b style="text-transform: uppercase">Note:</b>
              A non-refundable {{ get(getCurrentSchool, 'app_fee_name', '').toLowerCase() || 'application fee' }} of
              <b>{{ $n(get(classSch, 'program.application_fee', 0), 'currency', 'en-US') }}</b> is required for online
              registration submissions. Before registering, please make sure to contact us to make sure all of your
              questions are answered.
            </span>
          </span>
        </b-skeleton-wrapper>
      </div>

      <b-form class="col-md-12 px-0 page-section pt-0 pb-5" @submit.prevent="showApplicationForm">
        <div class="card">
          <div class="card-header bg-light">
            <h5 class="my-0">Class Information</h5>
          </div>
          <div class="card-body">
            <div class="flex">
              <b-skeleton-wrapper :loading="isClassLoading">
                <template #loading>
                  <p class="lead text-white-50">
                    <b-skeleton width="70%"></b-skeleton>
                  </p>
                  <p class="lead text-white-50">
                    <b-skeleton width="60%"></b-skeleton>
                  </p>
                  <p class="lead text-white-50">
                    <b-skeleton width="50%"></b-skeleton>
                  </p>
                  <p class="lead text-white-50">
                    <b-skeleton width="40%"></b-skeleton>
                  </p>
                </template>
                <div class="icon-align mb-2" v-if="classSch.class_type === CLASS_SCHEDULE_TYPES.SCHEDULED">
                  <i class="fas fa-calendar-alt icon-16pt mr-1"></i><b class="mr-1 form-label">Start/End:</b>
                  {{ formatDateSimple(classSch.start_date) }} to
                  {{ formatDateSimple(classSch.end_date) }}
                </div>
                <div class="icon-align mb-2">
                  <i class="fas fa-map-marker-alt icon-16pt mr-1"></i> <b class="mr-1 form-label">Location:</b>
                  <a class="text-underline text-primary">{{ fullClassLocation }}</a>
                </div>
                <div class="icon-align mb-2">
                  <i class="fas fa-dollar-sign icon-16pt mr-1"></i>
                  <b class="mr-1 form-label">{{ get(getCurrentSchool, 'ttl_tuition_name') || 'Total Tuition' }}:</b>
                  {{ $n(totalTuition, 'currency', 'en-US') }}

                  <i
                    class="material-icons icon-16pt clickable-item text-muted"
                    v-b-popover.hover.top="
                      `You don't need to pay this tuition fee right now if you are sponsored by some agency. Contact school admin for more information`
                    "
                    >info</i
                  >
                </div>
                <div v-if="get(classSch, 'program.other_fees')" class="icon-align mb-2">
                  <i class="fas fa-dollar-sign icon-16pt mr-1"></i>
                  <b class="mr-1 form-label">Other Fees:</b>
                  {{ $n(classSch.program.other_fees, 'currency', 'en-US') }}
                  <span class="text-muted ml-1">(paid separately)</span>
                </div>
                <div class="icon-align mb-2">
                  <i class="fas fa-calendar-week icon-16pt mr-1"></i> <b class="mr-1 form-label">Total Weeks:</b>
                  {{ $n(classSch.total_weeks, 'singleDecimal', 'en-US') }}
                </div>
                <div class="icon-align mb-2">
                  <i class="fas fa-clock icon-16pt mr-1"></i> <b class="mr-1 form-label">Total Hours:</b>
                  {{ $n(classSch.total_hours, 'singleDecimal', 'en-US') }}
                </div>
                <div class="icon-align mb-2" v-if="classSch.orientation_date">
                  <i class="fas fa-calendar-day icon-16pt mr-1"></i> <b class="mr-1 form-label">Orientation Date:</b>
                  {{ formatDateSimple(classSch.orientation_date) }}
                </div>
                <div class="icon-align mb-2">
                  <i class="fas fa-clipboard-list icon-16pt mr-1"></i>
                  <b class="mr-1 form-label">Schedule:</b>
                  {{
                    classSch.class_type === CLASS_SCHEDULE_TYPES.SCHEDULED
                      ? $t(`scheduleTypes.${classSch.schedule_type}`)
                      : 'Self-Paced'
                  }}
                </div>
              </b-skeleton-wrapper>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header bg-light">
            <h5 class="my-0">Student Information</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <b-form-group label="First Name*" label-for="firstname" label-class="form-label" class="col-md-6">
                <b-form-input
                  id="firstname"
                  :placeholder="$t('userMsgs.firstName')"
                  v-model.trim="user.firstName"
                  :state="!$v.user.firstName.required && $v.user.firstName.$dirty ? false : null"
                />
                <b-form-invalid-feedback v-if="!$v.user.firstName.required"
                  >This field is required.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group label="Last Name*" label-for="lastname" label-class="form-label" class="col-md-6">
                <b-form-input
                  id="lastname"
                  :placeholder="$t('userMsgs.lastName')"
                  v-model.trim="user.lastName"
                  :state="!$v.user.lastName.required && $v.user.lastName.$dirty ? false : null"
                />
                <b-form-invalid-feedback v-if="!$v.user.lastName.required"
                  >This field is required.</b-form-invalid-feedback
                >
              </b-form-group>
            </div>

            <b-form-group label="Email Address*" label-for="email" label-class="form-label">
              <b-form-input
                :disabled="$route.query.regId ? true : false"
                id="email"
                :placeholder="$t('authMsgs.emailAddr')"
                type="email"
                v-model.trim="user.email"
                :state="(!$v.user.email.required || !$v.user.email.email) && $v.user.$dirty ? false : null"
              />
              <b-form-invalid-feedback v-if="!$v.user.email.email">
                Invalid email. Please make sure that it's in correct format i.e.
                test@example.com.</b-form-invalid-feedback
              >
              <b-form-invalid-feedback v-else>This field is required.</b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="Phone*" label-for="phone" label-class="form-label">
              <b-form-input
                id="phone"
                placeholder="(888) 689 - 1235"
                v-model="user.phone"
                v-mask="'(###) ### - ####'"
                :state="
                  (!$v.user.phone.required || !$v.user.phone.isCorrectFormat) && $v.user.phone.$dirty ? false : null
                "
              />
              <b-form-invalid-feedback v-if="!$v.user.phone.required">
                This field is required.
              </b-form-invalid-feedback>
              <b-form-invalid-feedback v-else>
                Invalid phone number. Please make sure that it's in correct format i.e. (XXX) XXX - XXXX.
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="Birth Date*" label-for="gradDate" label-class="form-label">
              <date-picker
                v-model="student.birthday"
                type="date"
                format="MM/DD/YYYY"
                value-type="YYYY-MM-DD"
                style="width: 100%"
                id="birthday"
                lang="en"
                placeholder="MM/DD/YYYY"
                :input-class="
                  `mx-input ${
                    !$v.student.birthday.required && $v.student.birthday.$dirty ? 'form-control is-invalid' : ''
                  }`
                "
              ></date-picker>

              <b-form-invalid-feedback v-if="!$v.student.birthday.required && $v.student.birthday.$dirty"
                >This field is required.</b-form-invalid-feedback
              >
            </b-form-group>

            <b-form-group v-if="responseData.student_ssn !== STATIC_FIELD_TYPE.DISABLED">
              <label for="student_ssn" class="form-label">
                {{ responseData.student_ssn === STATIC_FIELD_TYPE.REQUIRED ? 'SSN*' : 'SSN' }}</label
              >
              <md-icon
                class="mb-1"
                style="font-size: 16px; color: grey"
                v-b-popover.hover.right
                :title="isFourDigitSSN ? 'Please enter last 4 digits of your SSN.' : 'Please enter your complete SSN.'"
                >info</md-icon
              >

              <div style="position: relative; display: flex; align-items: center; justify-content: flex-end">
                <b-input-group :prepend="isFourDigitSSN ? '***-**-' : ''">
                  <b-form-input
                    id="student_ssn"
                    :type="ssnPassType"
                    :placeholder="isFourDigitSSN ? '****' : '*********'"
                    :v-mask="isFourDigitSSN ? '####' : '###-##-####'"
                    v-model="student.student_ssn"
                    :state="
                      (!$v.student.student_ssn.required || !$v.student.student_ssn.length) &&
                      $v.student.student_ssn.$dirty
                        ? false
                        : null
                    "
                    :maxlength="isFourDigitSSN ? 4 : 9"
                  />
                  <b-form-invalid-feedback v-if="!$v.student.student_ssn.required"
                    >This field is required.</b-form-invalid-feedback
                  >
                  <b-form-invalid-feedback v-else-if="!$v.student.student_ssn.length"
                    >Please enter complete ssn.</b-form-invalid-feedback
                  >
                </b-input-group>

                <span style="position: absolute; margin-right: 6px" @click="changeField()" class="ml-1 my-auto">
                  <md-icon style="cursor: pointer; font-size: 21px; color: grey">{{
                    visibility ? 'visibility' : 'visibility_off'
                  }}</md-icon>
                </span>
              </div>
            </b-form-group>

            <b-form-group
              :label="
                `Language Preference(s)${responseData.lang_preferences === STATIC_FIELD_TYPE.REQUIRED ? '*' : ''}`
              "
              label-for="lang_preferences"
              label-class="form-label"
              v-if="responseData.lang_preferences !== STATIC_FIELD_TYPE.DISABLED"
            >
              <v-select
                id="lang_preferences"
                class="form-control v-select-custom"
                label="name"
                v-model="student.lang_preferences"
                :reduce="item => item.value"
                placeholder="Select Preferred Language"
                :options="langOptions"
                :class="
                  !$v.student.lang_preferences.required && $v.student.lang_preferences.$dirty
                    ? 'form-control is-invalid'
                    : ''
                "
                multiple
              >
              </v-select>
              <b-form-invalid-feedback
                :state="!$v.student.lang_preferences.required && $v.student.lang_preferences.$dirty ? false : null"
                >This field is required.</b-form-invalid-feedback
              >
            </b-form-group>

            <b-form-group
              :label="responseData.gender === STATIC_FIELD_TYPE.REQUIRED ? 'Gender*' : 'Gender'"
              label-for="gender"
              label-class="form-label"
              v-if="responseData.gender !== STATIC_FIELD_TYPE.DISABLED"
            >
              <v-select
                id="gender"
                class="form-control v-select-custom"
                label="text"
                v-model="user.gender"
                :reduce="item => item.value"
                placeholder="Select your gender"
                :options="genderOptions"
                :class="!$v.user.gender.required && $v.user.gender.$dirty ? 'form-control is-invalid' : ''"
              >
              </v-select>
              <b-form-invalid-feedback :state="!$v.user.gender.required && $v.user.gender.$dirty ? false : null"
                >This field is required.</b-form-invalid-feedback
              >
            </b-form-group>

            <b-form-group
              :label="responseData.ethnicity === STATIC_FIELD_TYPE.REQUIRED ? 'Ethnicity*' : 'Ethnicity'"
              label-for="ethnicity"
              label-class="form-label"
              v-if="responseData.ethnicity !== STATIC_FIELD_TYPE.DISABLED"
            >
              <v-select
                id="ethnicity"
                class="form-control v-select-custom"
                label="text"
                v-model="ethnicity"
                :reduce="r => r.value"
                placeholder="Select an Option"
                :options="ethnicityOptions"
                :class="!$v.ethnicity.required && $v.ethnicity.$dirty ? 'form-control is-invalid' : ''"
              >
              </v-select>
              <b-form-invalid-feedback :state="!$v.ethnicity.required && $v.ethnicity.$dirty ? false : null"
                >This field is required.</b-form-invalid-feedback
              >
              <b-form-input
                id="ethnicity_other"
                class="mt-1"
                placeholder="Please specify"
                v-model="ethnicity_other"
                required
                v-if="ethnicity === 'other'"
                :state="!$v.ethnicity_other.required && $v.ethnicity_other.$dirty ? false : null"
              />

              <b-form-invalid-feedback
                v-if="ethnicity === 'other'"
                :state="
                  (!$v.ethnicity.required && $v.ethnicity.$dirty) ||
                  (!$v.ethnicity_other.required && $v.ethnicity_other.$dirty)
                    ? false
                    : null
                "
                >This field is required.</b-form-invalid-feedback
              >
            </b-form-group>

            <!-- Address Fields -->
            <b-form-group
              :label="responseData.address === STATIC_FIELD_TYPE.REQUIRED ? 'Address*' : 'Address'"
              label-for="address"
              label-class="form-label"
              v-if="responseData.address !== STATIC_FIELD_TYPE.DISABLED"
            >
              <b-form-input
                id="address"
                :placeholder="$t('addressMsgs.address')"
                v-model="student.address"
                :state="!$v.student.address.required && $v.student.address.$dirty ? false : null"
              />
              <b-form-invalid-feedback :state="!$v.student.address.required && $v.student.address.$dirty ? false : null"
                >This field is required.</b-form-invalid-feedback
              >
            </b-form-group>

            <div class="row">
              <b-form-group
                :label="responseData.city === STATIC_FIELD_TYPE.REQUIRED ? 'City*' : 'City'"
                label-for="city"
                label-class="form-label"
                class="col-md-6"
                v-if="responseData.city !== STATIC_FIELD_TYPE.DISABLED"
              >
                <b-form-input
                  id="city"
                  :placeholder="$t('addressMsgs.city')"
                  v-model="student.city"
                  :state="!$v.student.city.required && $v.student.city.$dirty ? false : null"
                />
                <b-form-invalid-feedback :state="!$v.student.city.required && $v.student.city.$dirty ? false : null"
                  >This field is required.</b-form-invalid-feedback
                >
              </b-form-group>
              <b-form-group
                :label="responseData.state === STATIC_FIELD_TYPE.REQUIRED ? 'State*' : 'State'"
                label-for="state"
                label-class="form-label"
                class="col-md-6"
                v-if="responseData.state !== STATIC_FIELD_TYPE.DISABLED"
              >
                <v-select
                  id="state"
                  class="form-control v-select-custom"
                  label="text"
                  v-model="student.state"
                  :reduce="state => state.value"
                  placeholder="Select State"
                  :options="stateOptions"
                  :class="!$v.student.state.required && $v.student.state.$dirty ? 'form-control is-invalid' : ''"
                >
                </v-select>
                <b-form-invalid-feedback :state="!$v.student.state.required && $v.student.state.$dirty ? false : null"
                  >This field is required.</b-form-invalid-feedback
                >
              </b-form-group>
            </div>

            <div class="row">
              <b-form-group
                :label="responseData.zipcode === STATIC_FIELD_TYPE.REQUIRED ? 'Zipcode*' : 'Zipcode'"
                label-for="zipcode"
                label-class="form-label"
                class="col-md-6"
                v-if="responseData.zipcode !== STATIC_FIELD_TYPE.DISABLED"
              >
                <b-form-input
                  id="zipcode"
                  :placeholder="$t('addressMsgs.zipcode')"
                  v-model="student.zipcode"
                  :state="!$v.student.zipcode.required && $v.student.zipcode.$dirty ? false : null"
                />
                <b-form-invalid-feedback
                  :state="!$v.student.zipcode.required && $v.student.zipcode.$dirty ? false : null"
                  >This field is required.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                :label="responseData.country === STATIC_FIELD_TYPE.REQUIRED ? 'Country*' : 'Country'"
                label-for="country"
                label-class="form-label"
                class="col-md-6"
                v-if="responseData.country !== STATIC_FIELD_TYPE.DISABLED"
              >
                <v-select
                  id="country"
                  class="form-control v-select-custom"
                  label="text"
                  v-model="student.country"
                  disabled
                  :reduce="country => country.value"
                  :placeholder="$t('addressMsgs.countryPlaceholder')"
                  :options="countryOptions"
                  :class="!$v.student.country.required && $v.student.country.$dirty ? 'form-control is-invalid' : ''"
                >
                </v-select>
                <b-form-invalid-feedback
                  :state="!$v.student.country.required && $v.student.country.$dirty ? false : null"
                  >This field is required.</b-form-invalid-feedback
                >
              </b-form-group>
            </div>

            <b-form-group
              :label="
                `Why are you interested in registering for the ${get(classSch, 'program.title', '')} program?${
                  responseData.registration_reason === STATIC_FIELD_TYPE.REQUIRED ? '*' : ''
                }`
              "
              label-for="registration_reason"
              label-class="form-label"
              v-if="responseData.registration_reason !== STATIC_FIELD_TYPE.DISABLED"
            >
              <v-select
                id="registration_reason"
                class="form-control v-select-custom"
                label="text"
                v-model="registration_reason"
                :reduce="r => r.value"
                placeholder="Select the reason for registration"
                :options="allReasons"
                :class="
                  !$v.registration_reason.required && $v.registration_reason.$dirty ? 'form-control is-invalid' : ''
                "
              >
              </v-select>
              <b-form-invalid-feedback
                :state="!$v.registration_reason.required && $v.registration_reason.$dirty ? false : null"
                >This field is required.</b-form-invalid-feedback
              >
              <b-form-input
                id="other_registration_reason"
                class="mt-1"
                placeholder="Please specify"
                v-model="other_registration_reason"
                required
                v-if="registration_reason === 'other'"
                :state="!$v.other_registration_reason.required && $v.other_registration_reason.$dirty ? false : null"
              />

              <b-form-invalid-feedback
                v-if="registration_reason === 'other'"
                :state="
                  (!$v.registration_reason.required && $v.registration_reason.$dirty) ||
                  (!$v.other_registration_reason.required && $v.other_registration_reason.$dirty)
                    ? false
                    : null
                "
                >This field is required.</b-form-invalid-feedback
              >
            </b-form-group>

            <b-form-group
              :label="
                `How did you hear about our ${get(classSch, 'program.title', '')} program?${
                  responseData.reference === STATIC_FIELD_TYPE.REQUIRED ? '*' : ''
                }`
              "
              label-for="reference"
              label-class="form-label"
              v-if="responseData.reference !== STATIC_FIELD_TYPE.DISABLED"
            >
              <v-select
                id="reference"
                class="form-control v-select-custom"
                label="text"
                v-model="reference"
                :reduce="r => r.value"
                placeholder="Select reference"
                :options="allReferals"
                :class="!$v.reference.required && $v.reference.$dirty ? 'form-control is-invalid' : ''"
              >
              </v-select>
              <b-form-invalid-feedback :state="!$v.reference.required && $v.reference.$dirty ? false : null"
                >This field is required.</b-form-invalid-feedback
              >
              <b-form-input
                id="other_reference"
                class="mt-1"
                placeholder="Please specify"
                v-model="other_reference"
                required
                v-if="reference === 'other'"
                :state="!$v.other_reference.required && $v.other_reference.$dirty ? false : null"
              />

              <b-form-invalid-feedback
                v-if="reference === 'other'"
                :state="
                  (!$v.reference.required && $v.reference.$dirty) ||
                  (!$v.other_reference.required && $v.other_reference.$dirty)
                    ? false
                    : null
                "
                >This field is required.</b-form-invalid-feedback
              >
            </b-form-group>
          </div>
        </div>

        <!-- Student Profile Info -->

        <div class="card">
          <div class="card-header bg-light">
            <h5 class="my-0">Career Information</h5>
          </div>
          <div class="card-body">
            <b-form-group
              label="Do you have a High School Diploma/ GED?*"
              label-for="ged_or_diploma"
              label-class="form-label"
            >
              <b-form-radio-group
                id="ged_or_diploma"
                v-model="student.ged_or_diploma"
                :options="yesNoOptions"
                required
                :state="!$v.student.ged_or_diploma.required && $v.student.ged_or_diploma.$dirty ? false : null"
              ></b-form-radio-group>
              <b-form-invalid-feedback
                :state="!$v.student.ged_or_diploma.required && $v.student.ged_or_diploma.$dirty ? false : null"
                >This field is required.</b-form-invalid-feedback
              >
            </b-form-group>

            <b-form-group :label="`Graduation Year`" label-for="gradDate" label-class="form-label">
              <date-picker
                v-model="student.diploma_date"
                type="year"
                format="YYYY"
                style="width: 100%"
                value-type="date"
                id="diploma_date"
                lang="en"
                placeholder="No Date Selected"
              ></date-picker>
            </b-form-group>

            <b-form-group
              label="Have you been certified before?*"
              label-for="certified_before"
              label-class="form-label"
              v-slot="{ ariaDescribedby }"
            >
              <b-form-radio-group
                id="certified_before"
                v-model="student.certified_before"
                :options="yesNoOptions"
                :aria-describedby="ariaDescribedby"
                required
                :state="!$v.student.certified_before.required && $v.student.certified_before.$dirty ? false : null"
              ></b-form-radio-group>
              <b-form-invalid-feedback
                :state="!$v.student.certified_before.required && $v.student.certified_before.$dirty ? false : null"
                >This field is required.</b-form-invalid-feedback
              >
            </b-form-group>

            <b-form-group
              :label="
                `Where do you currently work?${responseData.occupation === STATIC_FIELD_TYPE.REQUIRED ? '*' : ''}`
              "
              label-for="occupation"
              label-class="form-label"
              v-if="responseData.occupation !== STATIC_FIELD_TYPE.DISABLED"
            >
              <b-form-input
                id="occupation"
                placeholder="Please enter where your currently work?"
                v-model="student.occupation"
                :state="!$v.student.occupation.required && $v.student.occupation.$dirty ? false : null"
              />

              <b-form-invalid-feedback
                :state="!$v.student.occupation.required && $v.student.occupation.$dirty ? false : null"
                >This field is required.</b-form-invalid-feedback
              >
            </b-form-group>

            <b-form-group
              label="Are you interested in receiving new opportunities from employers we partner with?*"
              label-for="career_service_interest"
              label-class="form-label"
              v-slot="{ ariaDescribedby }"
            >
              <b-form-radio-group
                id="career_service_interest"
                v-model="student.career_service_interest"
                :options="yesNoOptions"
                :aria-describedby="ariaDescribedby"
                required
                :state="
                  !$v.student.career_service_interest.required && $v.student.career_service_interest.$dirty
                    ? false
                    : null
                "
              ></b-form-radio-group>
              <b-form-invalid-feedback
                :state="
                  !$v.student.career_service_interest.required && $v.student.career_service_interest.$dirty
                    ? false
                    : null
                "
                >This field is required.</b-form-invalid-feedback
              >
            </b-form-group>

            <!-- Work Schedule Fields -->
            <b-form-group
              :label="
                `What type(s) of facilities do you prefer to work at?${
                  responseData.interested_facility_types === STATIC_FIELD_TYPE.REQUIRED ? '*' : ''
                }`
              "
              label-for="interested_facility_types"
              label-class="form-label"
              v-if="responseData.interested_facility_types !== STATIC_FIELD_TYPE.DISABLED"
            >
              <v-select
                id="interested_facility_types"
                class="form-control v-select-custom"
                label="text"
                v-model="interested_facility_types"
                :reduce="item => item.value"
                placeholder="Select preferred facility type(s)"
                :options="facilityTypeOptions"
                multiple
                :class="
                  !$v.interested_facility_types.required && $v.interested_facility_types.$dirty
                    ? 'form-control is-invalid'
                    : ''
                "
              >
              </v-select>
              <b-form-invalid-feedback
                :state="!$v.interested_facility_types.required && $v.interested_facility_types.$dirty ? false : null"
                >This field is required.</b-form-invalid-feedback
              >
            </b-form-group>
            <b-form-group
              :label="
                `What type(s) of schedule do you prefer to work?${
                  responseData.desired_work_type === STATIC_FIELD_TYPE.REQUIRED ? '*' : ''
                }`
              "
              label-for="desired_work_type"
              label-class="form-label"
              v-if="responseData.desired_work_type !== STATIC_FIELD_TYPE.DISABLED"
            >
              <v-select
                id="desired_work_type"
                class="form-control v-select-custom"
                label="text"
                v-model="student.desired_work_type"
                :reduce="item => item.value"
                placeholder="Select preferred work schedule(s)"
                :options="workTypeOptions"
                multiple
                :class="
                  !$v.student.desired_work_type.required && $v.student.desired_work_type.$dirty
                    ? 'form-control is-invalid'
                    : ''
                "
              >
              </v-select>
              <b-form-invalid-feedback
                :state="!$v.student.desired_work_type.required && $v.student.desired_work_type.$dirty ? false : null"
                >This field is required.</b-form-invalid-feedback
              >
            </b-form-group>

            <b-form-group
              :label="
                `What time(s) do you prefer to work?${
                  responseData.desired_work_time === STATIC_FIELD_TYPE.REQUIRED ? '*' : ''
                }`
              "
              label-for="desired_work_time"
              label-class="form-label"
              v-if="responseData.desired_work_time !== STATIC_FIELD_TYPE.DISABLED"
            >
              <v-select
                id="desired_work_time"
                class="form-control v-select-custom"
                label="text"
                v-model="student.desired_work_time"
                :reduce="item => item.value"
                placeholder="Select preferred work time(s)"
                :options="workTimeOptions"
                multiple
                :class="
                  !$v.student.desired_work_time.required && $v.student.desired_work_time.$dirty
                    ? 'form-control is-invalid'
                    : ''
                "
              >
              </v-select>
              <b-form-invalid-feedback
                :state="!$v.student.desired_work_time.required && $v.student.desired_work_time.$dirty ? false : null"
                >This field is required.</b-form-invalid-feedback
              >
            </b-form-group>

            <b-form-group
              :label="
                `What day(s) do you prefer to work?${
                  responseData.desired_work_day === STATIC_FIELD_TYPE.REQUIRED ? '*' : ''
                }`
              "
              label-for="desired_work_day"
              label-class="form-label"
              v-if="responseData.desired_work_day !== STATIC_FIELD_TYPE.DISABLED"
            >
              <v-select
                id="desired_work_day"
                class="form-control v-select-custom"
                label="text"
                v-model="student.desired_work_day"
                :reduce="item => item.value"
                placeholder="Select preferred work day(s)"
                :options="workDayOptions"
                multiple
                :class="
                  !$v.student.desired_work_day.required && $v.student.desired_work_day.$dirty
                    ? 'form-control is-invalid'
                    : ''
                "
              >
              </v-select>
              <b-form-invalid-feedback
                :state="!$v.student.desired_work_day.required && $v.student.desired_work_day.$dirty ? false : null"
                >This field is required.</b-form-invalid-feedback
              >
            </b-form-group>

            <b-form-group
              :label="
                `What distance are you willing to travel for work?${
                  responseData.work_travel === STATIC_FIELD_TYPE.REQUIRED ? '*' : ''
                }`
              "
              label-for="work_travel"
              label-class="form-label"
              v-if="responseData.work_travel !== STATIC_FIELD_TYPE.DISABLED"
            >
              <v-select
                id="work_travel"
                class="form-control v-select-custom"
                label="text"
                v-model="student.work_travel"
                :reduce="item => item.value"
                placeholder="Select preferred mile(s)"
                :options="workTravelOptions"
                :class="
                  !$v.student.work_travel.required && $v.student.work_travel.$dirty ? 'form-control is-invalid' : ''
                "
              >
              </v-select>
              <b-form-invalid-feedback
                :state="!$v.student.work_travel.required && $v.student.work_travel.$dirty ? false : null"
                >This field is required.</b-form-invalid-feedback
              >
            </b-form-group>

            <b-form-group
              label="Resume (Optional)"
              label-for="resume"
              label-class="form-label"
              class="row-align-items-center"
              v-if="responseData.resume_url !== STATIC_FIELD_TYPE.DISABLED"
            >
              <b-media class="align-items-center" vertical-align="center">
                <b-form-file
                  id="resume"
                  placeholder="Select Resume File"
                  :browse-text="$t('generalMsgs.browse')"
                  v-model="selectedUploadFile.resume"
                  @input="uploadFile('resume', 'documents', 'resume_url')"
                  :disabled="isUploading.resume"
                  accept=".pdf, .docx, .doc"
                  :state="!$v.student.resume_url.required && $v.student.resume_url.$dirty ? false : null"
                />
              </b-media>
              <b-form-invalid-feedback
                :state="!$v.student.resume_url.required && $v.student.resume_url.$dirty ? false : null"
                >This field is required.</b-form-invalid-feedback
              >
            </b-form-group>
            <b-form-group
              label="Career Profile Image (Optional)"
              label-for="avatar"
              label-class="form-label"
              class="row-align-items-center"
            >
              <b-media class="align-items-center" vertical-align="center">
                <user-avatar
                  slot="aside"
                  rounded="lg"
                  size="lg"
                  :isLoading="isUploading.avatar"
                  :user="user"
                  url-field="avatarUrl"
                  first-name-field="firstName"
                  last-name-field="lastName"
                >
                </user-avatar>

                <image-uploader
                  @image="e => setImage(e, 'avatar', 'images')"
                  :isUploading="isUploading.avatar"
                  :isRequired="false"
                  placeholder="Select image for career profile"
                />
              </b-media>
            </b-form-group>
          </div>
        </div>

        <div class="card" v-for="section in sections" :key="`sec-${section.id}`">
          <div class="card-header bg-light">
            <h5 class="my-0">{{ section.title }}</h5>
          </div>
          <div class="card-body">
            <b-form-group
              :label="ques.is_required ? `${get(ques, 'question.title')}*` : get(ques, 'question.title')"
              :label-for="`section-${section.id}-question-${ques.question.id}`"
              label-class="form-label"
              v-slot="{ ariaDescribedby }"
              v-for="ques in section.sectionquestion_set"
              :key="`sec-que-${ques.id}`"
            >
              <b-form-radio-group
                v-if="ques.question.type === QUES_TYPES.BOOLEAN"
                :id="`section-${section.id}-question-${ques.question.id}`"
                v-model="customSectionData[`section-${section.id}`][`question-${ques.question.id}`]"
                :options="get(ques.question, 'extra.options', [])"
                :aria-describedby="ariaDescribedby"
                :state="
                  !get($v, `customSectionData.section-${section.id}.question-${ques.question.id}.required`, true) &&
                  get($v, `customSectionData.section-${section.id}.question-${ques.question.id}.$dirty`, false)
                    ? false
                    : null
                "
                :required="ques.is_required"
              ></b-form-radio-group>

              <b-form-input
                :id="`section-${section.id}-question-${ques.question.id}`"
                v-if="ques.question.type === QUES_TYPES.SHORT_TEXT"
                :placeholder="get(ques.question, 'placeholder', 'Please write your answer here.')"
                v-model="customSectionData[`section-${section.id}`][`question-${ques.question.id}`]"
                :state="
                  !get($v, `customSectionData.section-${section.id}.question-${ques.question.id}.required`, true) &&
                  get($v, `customSectionData.section-${section.id}.question-${ques.question.id}.$dirty`, false)
                    ? false
                    : null
                "
                :required="ques.is_required"
              />
              <b-form-textarea
                v-if="ques.question.type === QUES_TYPES.LONG_TEXT"
                :id="`section-${section.id}-question-${ques.question.id}`"
                class="form-control"
                rows="10"
                :placeholder="get(ques.question, 'placeholder', 'Please write your answer here.')"
                v-model="customSectionData[`section-${section.id}`][`question-${ques.question.id}`]"
                :state="
                  !get($v, `customSectionData.section-${section.id}.question-${ques.question.id}.required`, true) &&
                  get($v, `customSectionData.section-${section.id}.question-${ques.question.id}.$dirty`, false)
                    ? false
                    : null
                "
                :required="ques.is_required"
              ></b-form-textarea>

              <b-media
                class="align-items-center"
                vertical-align="center"
                v-if="ques.question.type === QUES_TYPES.FILE_TYPE"
              >
                <b-form-file
                  :id="`section-${section.id}-question-${ques.question.id}`"
                  :placeholder="get(ques.question, 'placeholder', 'Select File')"
                  :browse-text="$t('generalMsgs.browse')"
                  v-model="selectedQueUploadFile[`sec-${section.id}-que-${ques.question.id}`]"
                  @input="uploadFile('file_type', 'documents', '', section.id, ques.question.id)"
                  :disabled="isQueFileUploading[`sec-${section.id}-que-${ques.question.id}`]"
                  :required="ques.is_required && !selectedQueUploadFile[`sec-${section.id}-que-${ques.question.id}`]"
                />
              </b-media>

              <v-select
                v-if="ques.question.type === QUES_TYPES.SINGLE_SELECT"
                :id="`section-${section.id}-question-${ques.question.id}`"
                class="form-control v-select-custom"
                label="text"
                item-text="text"
                v-model="customSectionData[`section-${section.id}`][`question-${ques.question.id}`]"
                :reduce="ins => ins.value"
                :placeholder="get(ques.question, 'placeholder', 'Please write your answer here.')"
                :options="get(ques.question, 'extra.options', [])"
                :class="
                  !get($v, `customSectionData.section-${section.id}.question-${ques.question.id}.required`, true) &&
                  get($v, `customSectionData.section-${section.id}.question-${ques.question.id}.$dirty`, false)
                    ? 'form-control is-invalid'
                    : ''
                "
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    :required="
                      ques.is_required && !customSectionData[`section-${section.id}`][`question-${ques.question.id}`]
                    "
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
                <template slot="option" slot-scope="option"> {{ option.text }} </template>
                <template slot="selected-option" slot-scope="option">
                  {{ option.text }}
                </template>
              </v-select>
              <v-select
                v-if="ques.question.type === QUES_TYPES.MULTI_SELECT"
                :id="`section-${section.id}question-${ques.question.id}`"
                class="form-control v-select-custom"
                label="text"
                item-text="text"
                v-model="customSectionData[`section-${section.id}`][`question-${ques.question.id}`]"
                :reduce="ins => ins.value"
                :placeholder="get(ques.question, 'placeholder', 'Please write your answer here.')"
                :options="get(ques.question, 'extra.options', [])"
                :class="
                  !get($v, `customSectionData.section-${section.id}.question-${ques.question.id}.required`, true) &&
                  get($v, `customSectionData.section-${section.id}.question-${ques.question.id}.$dirty`, false)
                    ? 'form-control is-invalid'
                    : ''
                "
                multiple
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    :required="
                      ques.is_required &&
                        !get(customSectionData[`section-${section.id}`][`question-${ques.question.id}`], 'length')
                    "
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
                <template slot="option" slot-scope="option"> {{ option.text }} </template>
                <template slot="selected-option" slot-scope="option">
                  {{ option.text }}
                </template>
              </v-select>
              <b-form-invalid-feedback
                :state="
                  !get($v, `customSectionData.section-${section.id}.question-${ques.question.id}.required`, true) &&
                  get($v, `customSectionData.section-${section.id}.question-${ques.question.id}.$dirty`, false)
                    ? false
                    : null
                "
                >This field is required.</b-form-invalid-feedback
              >
            </b-form-group>
          </div>
        </div>

        <div class="card" v-if="responseData.plan_to_pay !== STATIC_FIELD_TYPE.DISABLED">
          <div class="card-header bg-light">
            <h5 class="my-0">{{ get(getCurrentSchool, 'tuition_fee_name') || 'Tuition' }} and Payment Plan</h5>
          </div>
          <div class="card-body">
            <b-skeleton-wrapper :loading="isClassLoading">
              <template #loading>
                <p class="lead text-white-50">
                  <b-skeleton width="70%"></b-skeleton>
                </p>
                <p class="lead text-white-50">
                  <b-skeleton width="60%"></b-skeleton>
                </p>
                <p class="lead text-white-50">
                  <b-skeleton width="50%"></b-skeleton>
                </p>
              </template>

              <!-- Free plan summary -->
              <template v-if="payment_option === STD_REG_PAY_OPTIONS.FREE_PLAN">
                <div class="mb-3">
                  <div class="font-weight-semibold">
                    When do you plan to pay the remaining
                    {{ get(getCurrentSchool, 'tuition_fee_name') || 'Tuition Fee' }} ({{
                      $n(totalTuition, 'currency', 'en-US')
                    }}){{ responseData.plan_to_pay === STATIC_FIELD_TYPE.REQUIRED ? '*' : '' }}?
                  </div>
                  <div class="text-muted mt-1">Free Plan</div>
                </div>
              </template>

              <b-form-group
                v-else-if="responseData.plan_to_pay !== STATIC_FIELD_TYPE.DISABLED"
                :label="
                  `How will you be paying your ${get(getCurrentSchool, 'tuition_fee_name') || 'tuition'}?${
                    responseData.plan_to_pay === STATIC_FIELD_TYPE.REQUIRED ? '*' : ''
                  }`
                "
                label-for="plan_to_pay"
                label-class="form-label"
              >
                <div
                  @click.prevent="
                    () => {
                      if (!$route.query.regId) {
                        plan_to_pay = option.value;
                        if (option.value !== 'self_pay') {
                          if (get(classSch, 'program.tuition_reg_req') === false) {
                            payment_option = STD_REG_PAY_OPTIONS.PAY_LATER;
                          }
                        }
                      }
                    }
                  "
                  :style="$route.query.regId ? 'cursor: not-allowed;' : 'cursor: pointer'"
                  class="card p-3 mb-2"
                  v-for="option in stdPlanToPayOptions(get(this.getCurrentSchool, 'tuition_fee_name'))"
                  :key="option.value"
                >
                  <b-form-radio
                    size="lg"
                    name="plan-to-pay-radio"
                    :value="option.value"
                    v-model="plan_to_pay"
                    :style="regLockedStyle"
                    :disabled="$route.query.regId ? true : false"
                    :class="!$v.plan_to_pay.required && $v.plan_to_pay.$dirty ? 'form-control is-invalid' : ''"
                  >
                    <i style="font-size: 23px" :class="`fas ${option.icon} payment-method-icon mr-1 mb-1`" />
                    <span style="font-size: 16px">
                      {{ option.text }}
                    </span>
                  </b-form-radio>
                  <span :class="option.description ? 'mt-2' : ''" :style="regLockedStyle">
                    {{ option.description }}
                  </span>
                  <div v-if="option.value === 'not_sure_yet'" class="mt-2" style="color: #6c757d; font-size: 14px;">
                    Please contact the school for more information regarding loans.
                  </div>
                  <div
                    v-if="option.value === 'sponsored_employer_agency'"
                    class="mt-2"
                    style="color: #6c757d; font-size: 14px;"
                  >
                    Please contact the school for more information regarding sponsors.
                  </div>

                  <!-- Nested Self Pay Options -->
                  <div v-if="plan_to_pay === 'self_pay' && option.value === 'self_pay'" class="mt-3 ml-4">
                    <div
                      @click.stop="
                        () => {
                          if (
                            !$route.query.regId &&
                            ![PROGRAM_PAYMENT_OPTIONS.PAY_LATER, PROGRAM_PAYMENT_OPTIONS.TUITION_REQ].includes(
                              get(classSch, 'program.allow_pymnt_option')
                            )
                          ) {
                            payment_option = nestedOption.value;
                          }
                        }
                      "
                      :style="$route.query.regId ? 'cursor: not-allowed; opacity: 0.6;' : 'cursor: pointer'"
                      v-for="nestedOption in STD_REG_FORM_PAY_OPTIONS"
                      :key="nestedOption.value"
                    >
                      <div class="card p-3 mb-2">
                        <b-form-radio
                          size="lg"
                          name="payment-option-radio"
                          :value="nestedOption.value"
                          v-model="payment_option"
                          :disabled="
                            $route.query.regId ||
                              [PROGRAM_PAYMENT_OPTIONS.PAY_LATER, PROGRAM_PAYMENT_OPTIONS.TUITION_REQ].includes(
                                get(classSch, 'program.allow_pymnt_option')
                              )
                          "
                          v-b-popover.hover.left
                          :title="
                            $route.query.regId
                              ? 'Payment option cannot be changed for initiated registrations'
                              : get(classSch, 'program.allow_pymnt_option') === PROGRAM_PAYMENT_OPTIONS.PAY_LATER
                              ? 'This option is disabled by admin'
                              : ''
                          "
                        >
                          <i
                            style="font-size: 23px"
                            :class="
                              `fas ${
                                nestedOption.value === 'pay_now' ? 'fa-credit-card' : 'fa-calendar-check'
                              } payment-method-icon mr-1 mb-1`
                            "
                          />
                          <span style="font-size: 16px">
                            {{
                              nestedOption.value === 'pay_now'
                                ? `Pay in Full Now (${$n(payNowDueToday, 'currency', 'en-US')})`
                                : `Pay Deposit Now (${$n(calcPrgApplicationFee, 'currency', 'en-US')})`
                            }}
                          </span>
                        </b-form-radio>
                        <span class="mt-2">
                          {{
                            nestedOption.value === 'pay_now'
                              ? 'Afterpay, Klarna, debit or credit card'
                              : 'Use payment plan for remaining balance'
                          }}
                        </span>
                      </div>
                    </div>
                    <div v-if="initiatedPaymentSummary" class="alert alert-info mt-2 mb-0 py-2 px-3">
                      <i class="fas fa-info-circle mr-1"></i>
                      <span style="font-size: 14px">{{ initiatedPaymentSummary }}</span>
                    </div>
                    <b-form-invalid-feedback
                      :state="!$v.payment_option.required && $v.payment_option.$dirty ? false : null"
                      >This field is required.</b-form-invalid-feedback
                    >

                    <!-- Payment plan choice. Only the self-pay + deposit path uses a plan,
                         and only a class offering more than one asks the student to pick. -->
                    <div
                      v-if="payment_option === STD_REG_PAY_OPTIONS.PAY_LATER && classPaymentPlans.length > 1"
                      class="mt-4"
                    >
                      <h5 class="plan-picker__heading">Choose your payment plan</h5>

                      <!-- Plans sit side by side where there is room, so they can be compared.
                           An ancestor handler calls preventDefault on click, which cancels the
                           radio's native check, so select the plan explicitly. -->
                      <div class="plan-grid">
                        <div
                          v-for="plan in classPaymentPlans"
                          :key="plan.plan_group"
                          class="plan-option"
                          :class="{ 'plan-option--selected': class_plan_group === plan.plan_group }"
                          @click.prevent="class_plan_group = plan.plan_group"
                        >
                          <div class="plan-option__head">
                            <b-form-radio
                              size="lg"
                              name="class-plan-radio"
                              :value="plan.plan_group"
                              v-model="class_plan_group"
                              class="plan-option__radio"
                            >
                              <span class="plan-option__name">{{ plan.plan_title }}</span>
                              <span class="plan-option__span">{{ plan.spanLabel }}</span>
                            </b-form-radio>
                          </div>

                          <ol class="installments">
                            <li
                              v-for="(installment, idx) in plan.installments"
                              :key="idx"
                              class="installment"
                            >
                              <span class="installment__marker">{{ idx + 1 }}</span>

                              <span class="installment__when">
                                <span class="installment__primary">{{ installment.primaryLabel }}</span>
                                <span class="installment__secondary">{{ installment.secondaryLabel }}</span>
                              </span>

                              <span class="installment__money">
                                <span class="installment__amount">{{
                                  $n(installment.displayAmount, 'currency', 'en-US')
                                }}</span>
                              </span>
                            </li>
                          </ol>
                        </div>
                      </div>

                      <b-form-invalid-feedback
                        :state="!$v.class_plan_group.required && $v.class_plan_group.$dirty ? false : null"
                        >Please select a payment plan.</b-form-invalid-feedback
                      >
                    </div>
                  </div>


                  <!-- Sponsored Employer/Agency Dropdown -->
                  <div
                    v-if="plan_to_pay === 'sponsored_employer_agency' && option.value === 'sponsored_employer_agency'"
                  >
                    <v-select
                      id="sponsorship_select"
                      class="form-control v-select-custom my-2"
                      label="title"
                      v-model="selectedSponsorship"
                      :reduce="sponsorship => sponsorship"
                      placeholder="Select sponsorship"
                      :options="sponsorshipOptions"
                      :clearable="false"
                      :disabled="$route.query.regId ? true : false"
                      :class="
                        !$v.selectedSponsorship.required && $v.selectedSponsorship.$dirty
                          ? 'form-control is-invalid'
                          : ''
                      "
                    >
                    </v-select>
                    <b-form-invalid-feedback
                      :state="!$v.selectedSponsorship.required && $v.selectedSponsorship.$dirty ? false : null"
                      >This field is required.</b-form-invalid-feedback
                    >
                  </div>
                </div>
                <b-form-invalid-feedback :state="!$v.plan_to_pay.required && $v.plan_to_pay.$dirty ? false : null"
                  >This field is required.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-skeleton-wrapper>
          </div>
        </div>

        <!-- Terms & Conditions Card -->
        <div class="card">
          <div class="card-header bg-light">
            <h5 class="my-0">Terms and Conditions</h5>
          </div>
          <div class="card-body">
            <b-form-group label-class="form-label">
              <b-form-checkbox v-model="termsAndConditions" name="check-button">
                <span style="font-weight: initial" class="text-black">
                  I understand and accept the
                  <a href="#" @click.prevent="showTermsModal = true" style="color: #3B86F5">terms and conditions</a>.
                </span>
              </b-form-checkbox>
            </b-form-group>

            <b-form-group label="Signature*" label-for="signature" label-class="form-label">
              <b-form-input
                id="signature"
                placeholder="Type Full Name"
                v-model="signature"
                :state="!$v.signature.required && $v.signature.$dirty ? false : null"
                maxlength="60"
              />

              <b-form-invalid-feedback v-if="!$v.signature.required">This field is required.</b-form-invalid-feedback>
            </b-form-group>

            <div class="text-dark" v-if="signature">Preview</div>
            <h1 class="signature-font">{{ signature }}</h1>
          </div>
        </div>

        <b-btn
          variant="primary"
          :disabled="isFormLoading || !termsAndConditions"
          style="width: 150px"
          type="submit"
          class="btn-normal float-right"
        >
          <i v-if="isLoading" class="fas fa-circle-notch fa-spin"></i>
          <span v-else>Continue</span>
        </b-btn>
      </b-form>
    </div>

    <!-- Product content -->
    <div
      :class="containerClass"
      v-else-if="showProducts && !showPaymentDetail && !showRefundPolicy"
      class="offset-lg-2 col-lg-8 col-md-12 bg-white border"
    >
      <product-card
        :class-sch="classSch"
        :products="products"
        :are-products-loading="areProductsLoading"
        :cart-arr="cartArr"
        :is-payment-details-loading="isPaymentDetailsLoading"
        :is-form-loading="isFormLoading"
        :is-pay-loading="isPayLoading"
        :is-loading="isLoading"
        @increase="incrementQuantity"
        @decrease="decrementQuantity"
        @updateCart="addToCart"
        @remove="removeFromCart"
        @back="backFromProductInfo"
        @continue="onSubmit"
      />
    </div>

    <div
      :class="containerClass"
      v-else-if="!showPaymentDetail && showRefundPolicy"
      class="offset-lg-2 col-lg-8 col-md-12 bg-white border"
    >
      <div class="d-flex justify-content-center mt-2 pt-2">
        <b-img :src="get(getCurrentSchool, 'logo_url')" height="110" />
      </div>
      <div class="d-flex justify-content-center mt-2 text-center">
        <h3 class="mb-0 font-weight-bolder" v-text="`${get(classSch, 'program.title')} Registration`" />
      </div>

      <div class="py-5" style="padding-inline: 100px;">
        <div
          class="my-3"
          v-safe-html="get(getCurrentSchool, 'cancellation_terms')"
          v-if="get(getCurrentSchool, 'cancellation_terms')"
        />

        <hr />

        <b-form-group>
          <b-form-checkbox id="checkbox" v-model="acceptRefundPolicy" name="checkbox">
            I,
            <b>
              {{ user.firstName }}
              {{ user.lastName }}
            </b>
            , have read the above stated terms and conditions. I hereby agree to the cancellation/refund policy of
            <b>
              {{ get(getCurrentSchool, 'name') }}
            </b>
            .
          </b-form-checkbox>
        </b-form-group>
        <span class="mb-2"> Date: {{ formatFullDate(new Date()) }} </span>

        <b-btn
          variant="primary"
          :disabled="isFormLoading || !acceptRefundPolicy"
          style="width: 150px"
          @click.prevent="acceptRefund"
          class="btn-normal float-right my-3"
        >
          <i v-if="isLoading" class="fas fa-circle-notch fa-spin"></i>
          <span v-else>Continue</span>
        </b-btn>
      </div>
    </div>

    <!-- Checkout content. -->

    <div :class="containerClass" v-else-if="showPaymentDetail" class="offset-lg-2 col-lg-8 col-md-12 bg-white border">
      <div class="d-flex justify-content-center mt-2 pt-2">
        <b-img :src="get(getCurrentSchool, 'logo_url')" height="110" />
      </div>
      <div class="d-flex justify-content-center mt-2 text-center">
        <h3 class="mb-0 font-weight-bolder" v-text="`${get(classSch, 'program.title')} Registration`" />
      </div>
      <div class="mx-3 mt-3 mb-4 text-center">
        <span style="font-size: 0.9125rem">
          Confirm the details below and add your payment information to complete the registration.
        </span>
      </div>
      <b-form class="col-md-12 px-0 page-section pt-0 pb-5 mb-5" @submit.prevent="pay">
        <div class="row px-0">
          <div class="col-md-7 d-flex align-items-stretch">
            <div class="card w-100">
              <div class="card-header bg-light">
                <h5 class="my-0">Student Summary</h5>
              </div>
              <div class="card-body">
                <div class="icon-align mb-2">
                  <i class="fas fa-user-alt icon-16pt mr-1"></i>{{ user.firstName }} {{ user.lastName }}
                </div>
                <div class="icon-align mb-2"><i class="fas fa-envelope icon-16pt mr-1"></i>{{ user.email }}</div>
                <div class="icon-align mb-2"><i class="fas fa-phone icon-16pt mr-1"></i>{{ user.phone }}</div>

                <div class="icon-align mb-2" v-if="enteredStdAddr">
                  <i class="fas fa-map-marker-alt icon-16pt mr-1"></i>{{ enteredStdAddr }}
                </div>
                <div class="icon-align mb-2">
                  <i class="fas fa-calendar-alt icon-16pt mr-1"></i>
                  <span v-if="classSch.start_date">
                    Classes starting from
                    {{ formatFullDate(classSch.start_date) }}
                  </span>
                  <span v-else>
                    Self-Paced
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-5 d-flex align-items-stretch">
            <div class="card w-100">
              <div class="card-header bg-light">
                <h5 class="my-0">Amount Due</h5>
              </div>
              <div class="card-body d-flex align-items-center">
                <div class="w-100">
                  <div
                    class="icon-align mb-2 d-flex justify-content-between"
                    v-if="payment_option === STD_REG_PAY_OPTIONS.PAY_NOW"
                  >
                    <b class="mr-1"> {{ get(getCurrentSchool, 'tuition_fee_name') || 'Tuition Fee' }}:</b>
                    {{
                      payment_option === STD_REG_PAY_OPTIONS.FREE_PLAN && !cartArr.length
                        ? $n(0, 'currency', 'en-US')
                        : $n(get(classSch, 'program.tuition_fee', 0), 'currency', 'en-US')
                    }}
                  </div>

                  <div class="icon-align mb-2 d-flex justify-content-between">
                    <b class="mr-1"> {{ get(getCurrentSchool, 'app_fee_name') || 'Application Fee' }}:</b>
                    {{ $n(calcPrgApplicationFee, 'currency', 'en-US') }}
                  </div>

                  <div class="icon-align mb-2 d-flex justify-content-between" v-if="get(cartArr, 'length')">
                    <b class="mr-1">Products:</b>
                    {{
                      payment_option === STD_REG_PAY_OPTIONS.FREE_PLAN && !cartArr.length
                        ? $n(0, 'currency', 'en-US')
                        : $n(totalAmount, 'currency', 'en-US')
                    }}
                  </div>

                  <div class="icon-align mb-2 d-flex justify-content-between">
                    <b class="mr-1">Online Service Fee:</b>
                    {{
                      (payment_option === STD_REG_PAY_OPTIONS.FREE_PLAN && !cartArr.length) ||
                      (payment_option === STD_REG_PAY_OPTIONS.PAY_LATER && !cartArr.length && waiveAppFee)
                        ? $n(0, 'currency', 'en-US')
                        : $n(calcServiceFee, 'currency', 'en-US')
                    }}
                  </div>
                  <hr />
                  <div class="d-flex justify-content-between">
                    <b>Total Amount Due:</b>
                    <b>{{
                      (payment_option === STD_REG_PAY_OPTIONS.FREE_PLAN && !cartArr.length) ||
                      (payment_option === STD_REG_PAY_OPTIONS.PAY_LATER && !cartArr.length && waiveAppFee)
                        ? $n(0, 'currency', 'en-US')
                        : $n(calTotalFee, 'currency', 'en-US')
                    }}</b>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="get(cartArr, 'length')">
          <product-checkout-card :cart-arr="cartArr" />
        </div>

        <div
          class="card"
          v-if="
            [STD_REG_PAY_OPTIONS.PAY_NOW].includes(payment_option) ||
              (payment_option === STD_REG_PAY_OPTIONS.FREE_PLAN && cartArr.length) ||
              (payment_option !== STD_REG_PAY_OPTIONS.PAY_LATER && cartArr.length) ||
              (payment_option === STD_REG_PAY_OPTIONS.PAY_LATER && cartArr.length && waiveAppFee) ||
              (payment_option !== STD_REG_PAY_OPTIONS.PAY_LATER &&
                cartArr.length &&
                get(classSch, 'program.application_fee')) ||
              (payment_option === STD_REG_PAY_OPTIONS.PAY_LATER && !waiveAppFee)
          "
        >
          <div class="card-header bg-light">
            <h5 class="my-0">Payment Information</h5>
          </div>

          <div class="card-body">
            <b-skeleton-wrapper :loading="isPaymentDetailsLoading">
              <template #loading>
                <p class="lead text-white-50">
                  <b-skeleton width="70%"></b-skeleton>
                </p>
                <p class="lead text-white-50">
                  <b-skeleton width="60%"></b-skeleton>
                </p>
                <p class="lead text-white-50">
                  <b-skeleton width="50%"></b-skeleton>
                </p>
              </template>
            </b-skeleton-wrapper>
            <stripe-element-payment
              ref="paymentRef"
              :pk="pk"
              :testMode="testMode"
              :elements-options="elementsOptions"
              :confirm-params="confirmParams"
              @loading="value => (isPayLoading = value)"
              @element-ready="() => (isPaymentDetailsLoading = false)"
            />
          </div>
        </div>
        <div class="d-flex justify-content-between">
          <b-btn
            variant="light"
            :disabled="isPayLoading"
            style="width: 150px"
            @click.prevent="backToForm"
            class="btn-normal float-right"
          >
            <span>Back</span>
          </b-btn>

          <b-btn
            variant="primary"
            :disabled="
              [STD_REG_PAY_OPTIONS.PAY_NOW, STD_REG_PAY_OPTIONS.PAY_LATER].includes(payment_option) && cartArr.length
                ? isPayLoading || isFormLoading || isPaymentDetailsLoading
                : false
            "
            style="width: 150px"
            type="submit"
            class="btn-normal float-right"
          >
            <i v-if="isPayLoading" class="fas fa-circle-notch fa-spin"></i>
            <span v-else>Register</span>
          </b-btn>
        </div>
      </b-form>
    </div>

    <!-- Registeration success component -->
    <div class="page-section" v-else-if="registeredSuccessfull && !showPaymentDetail && !showProducts">
      <div :class="containerClass" class="mt-5">
        <div class="page-section d-flex justify-content-center">
          <div class="card card-block card-stretch card-height col-md-8">
            <div class="card-body text-center">
              <i class="fas fa-check-circle fa-lg text-success mt-4 mb-4" style="font-size: 3rem" />
              <h4>Successfully Registered</h4>

              <p class="text-muted">
                {{
                  `You are successfully registered as a student in ${get(
                    classSch,
                    'program.title',
                    'class'
                  )} and will receive an e-mail shortly. For any
                queries, please contact the administrator.`
                }}
              </p>
              <a href="#" @click.prevent="goToHome" class="btn btn-primary"
                ><i class="fas fa-home mr-2"></i>Back to Home
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Registeration failure component -->
    <div class="page-section" v-else-if="registeredUnsuccessfull && !showPaymentDetail && !showProducts">
      <div :class="containerClass" class="mt-5">
        <div class="page-section d-flex justify-content-center">
          <div class="card card-block card-stretch card-height col-md-8">
            <div class="card-body text-center">
              <i class="fas fa-times-circle fa-lg text-danger mt-4 mb-4" style="font-size: 3rem" />
              <h4>Registration Failed!</h4>

              <p class="text-muted">
                Cannot register you in this class. Please try again later or contact the administrator.
              </p>
              <a href="#" @click.prevent="goToHome" class="btn btn-primary"
                ><i class="fas fa-home mr-2"></i>Back to Home
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="showApplication">
      <application-form :scholarship="selectedSponsorship" @ApplicationForm="ApplicationFormResponse" />
    </div>

    <reg-terms-modal :show-modal="showTermsModal" @close="showTermsModal = false"></reg-terms-modal>

    <b-modal
      v-model="showSuperadminSponsorshipAlert"
      hide-footer
      hide-header
      centered
      modal-class="sponsorship-alert-modal"
      content-class="sponsorship-alert-modal-content"
      body-class="sponsorship-alert-modal-body"
      @hide="onSuperadminSponsorshipAlertHide"
    >
      <button type="button" class="sponsorship-alert-close" @click="showSuperadminSponsorshipAlert = false">
        <i class="material-icons">close</i>
      </button>

      <div class="sponsorship-alert-header">
        <div class="sponsorship-alert-icon-wrap">
          <i class="material-icons">warning</i>
        </div>

        <h4 class="sponsorship-alert-title">Sponsorship Selected</h4>
      </div>

      <p class="sponsorship-alert-text mb-2">
        You selected <strong>{{ get(selectedSponsorship, 'title') }}</strong> sponsorship.
      </p>
      <p class="sponsorship-alert-text">
        Please review the sponsorship requirements before proceeding.
      </p>

      <div class="sponsorship-alert-warning-box">
        <i class="material-icons">warning</i>
        <span>
          Some sponsorships require approval or other conditions to be completed first. If you register before meeting
          those requirements, you may be responsible for course costs.
        </span>
      </div>

      <div
        class="sponsorship-alert-actions"
        :class="{ 'sponsorship-alert-actions-single': !superadminSponsorshipCtaLink }"
      >
        <b-btn
          v-if="superadminSponsorshipCtaLink"
          class="sponsorship-alert-btn sponsorship-alert-btn-outline"
          @click="redirectToSuperadminSponsorshipCta"
          >View Sponsorship Details</b-btn
        >
        <b-btn
          class="sponsorship-alert-btn sponsorship-alert-btn-primary"
          @click="continueRegistrationAfterSponsorshipAlert"
          >Continue Registration</b-btn
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { get, map } from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import { countries } from 'countries-list';
import generator from 'generate-password';
import Page from '@/components/Page.vue';
import UserAvatar from '../../../../components/User/UserAvatar.vue';
import DatePicker from 'vue2-datepicker';
import { required, requiredIf, email } from 'vuelidate/lib/validators';
import { StripeElementPayment } from '@vue-stripe/vue-stripe';
import ProductCard from './ProductCard.vue';
import ProductCheckoutCard from './ProductCheckoutCard.vue';
import ApplicationForm from './ApplicationForm.vue';
import {
  PHONE_FORMAT_REGEX,
  ETHNICITY_OPTIONS,
  STATIC_FIELD_TYPE,
  QUES_TYPES,
  STD_REG_REASON_OPTIONS,
  YES_NO_OPTIONS,
  GENDER_OPTIONS,
  STD_REG_REFERRAL_OPTIONS,
  STD_REG_FORM_PAY_OPTIONS,
  STD_REG_PAY_OPTIONS,
  STD_REG_MIN_SERVICE_FEE,
  PROGRAM_PAYMENT_OPTIONS,
  STD_PLAN_TO_PAY,
  SPONSORSHIP_SUBMISSION_TYPES,
  CLASS_SCHEDULE_TYPES,
  PAYMENT_TYPE,
} from '../../../../common/constants';
import {
  getLangOptions,
  formatDateSimple,
  formatToAPIDate,
  getWorkTravelOptions,
  formatFullDate,
  getClickableLink,
  stdPlanToPayOptions,
  titleize,
} from '../../../../common/utils';
import RegTermsModal from './RegTermsModal.vue';
import { captureException } from '@sentry/vue';
var UsaStates = require('usa-states').UsaStates;
import vSelect from 'vue-select';
import ImageUploader from '@/components/ImageUploader.vue';

export default {
  components: {
    UserAvatar,
    DatePicker,
    RegTermsModal,
    StripeElementPayment,
    ProductCard,
    ProductCheckoutCard,
    ApplicationForm,
    vSelect,
    ImageUploader,
  },
  extends: Page,
  layout: 'blank',

  data() {
    return {
      ssnPassType: 'password',
      visibility: false,
      title: 'Registration',
      registeredSuccessfull: false,
      registeredUnsuccessfull: false,
      pk: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
      testMode: process.env.VUE_APP_TEST_MODE === 'true',
      isPayLoading: false,
      isPaymentDetailsLoading: false,
      areProductsLoading: false,
      products: [],
      CLASS_SCHEDULE_TYPES,
      cartArr: [],
      elementsOptions: {
        appearance: { theme: 'stripe' }, // appearance options
        // 'clientSecret' being added below.
      },
      intentDraftId: null,
      confirmParams: {},
      isLoading: false,
      termsAndConditions: false,
      showTermsModal: false,
      showPaymentDetail: false,
      showRefundPolicy: false,
      acceptRefundPolicy: false,
      showProducts: false,
      school: null,
      user: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        repeatPassword: '',
        phone: '',
        bio: '',
        avatarUrl: '',
        gender: '',
      },
      student: {
        birthday: null,
        is_profile_visible: true,

        desired_work_type: [],
        desired_work_time: [],
        desired_work_day: [],
        work_travel: '',
        lang_preferences: ['en'],
        certified_before: false,
        ged_or_diploma: null,
        diploma_date: '',
        resume_url: '',
        address: '',
        zipcode: '',
        city: '',
        state: '',
        country: 'United States',

        career_service_interest: true,
        student_ssn: '',

        occupation: '',
      },
      plan_to_pay: STD_PLAN_TO_PAY.SELF_PAY,
      ethnicity: '',
      ethnicity_other: '',
      registration_reason: '',
      other_registration_reason: '',
      other_reference: '',
      reference: '',
      signature: '',
      interested_facility_types: [],

      payment_option: STD_REG_PAY_OPTIONS.PAY_NOW,
      class_plan_group: null,
      sendEmail: true,

      allReferals: STD_REG_REFERRAL_OPTIONS,
      allReasons: STD_REG_REASON_OPTIONS,
      fieldTypes: { password: 'text', repeatPassword: 'text' },
      STD_REG_FORM_PAY_OPTIONS,
      isPreEnrollLoading: false,
      allSchools: [],
      allPrograms: [],
      countryOptions: [],
      stateOptions: [],
      workExpOptions: [
        { value: '0-1', text: '0-1 year' },
        { value: '1-2', text: '1-2 years' },
        { value: '3-4', text: '3-4 years' },
        { value: '5-6', text: '5-6 years' },
        { value: '7+', text: '7+ years' },
      ],
      workDayOptions: [],
      workTypeOptions: [
        { value: 'part_time', text: 'Part-time' },
        { value: 'full_time', text: 'Full-time' },
        { value: 'not_sure', text: 'Not sure' },
      ],
      workTimeOptions: [
        { value: 'day', text: 'Day' },
        { value: 'evening', text: 'Evening' },
        { value: 'overnight', text: 'Overnight' },
      ],
      workTravelOptions: [],
      facilityTypeOptions: [
        { value: 'adult_day_care', text: 'Adult day care' },
        { value: 'assisted_living', text: 'Assisted living' },
        { value: 'hospital', text: 'Hospital' },
        { value: 'hospice_care', text: 'Hospice care' },
        { value: 'home_care', text: 'Home care' },
        { value: 'longterm_care', text: 'Long-term care' },
        { value: 'other', text: 'Other' },
      ],
      careerPreferences: [],
      profileVisOptions: [
        { value: true, text: 'Active' },
        { value: false, text: 'Paused' },
      ],
      langOptions: [],
      yesNoOptions: YES_NO_OPTIONS,
      genderOptions: GENDER_OPTIONS,
      ethnicityOptions: ETHNICITY_OPTIONS,
      classIdFromPreEnroll: null,
      errorStates: {
        password: null,
        userEmail: null,
        cnaLicenseNo: null,
        phone: null,
      },
      passErrorCode: null,

      isPassCopied: false,
      areSchoolsLoading: false,
      isLogoUploading: false,
      areCareerPrefsLoading: false,

      isUploading: {
        avatar: false,
        resume: false,
      },
      isQueFileUploading: {},
      selectedUploadFile: {
        avatar: null,
        resume: null,
      },
      selectedQueUploadFile: {},
      uploadPercent: { avatar: 0, resume: 0, file_type: {} },
      uploadCancelTokenSource: {
        avatar: null,
        resume: null,
        file_type: {},
      },
      classSch: {},
      isDataLoading: false,
      isClassLoading: false,
      responseData: {
        lang_preferences: null,
        desired_work_type: null,
        desired_work_time: null,
        desired_work_day: null,
        work_travel: null,
        interested_facility_types: null,
        student_ssn: null,
        reference: null,
        registration_reason: null,
        plan_to_pay: null,
        occupation: null,
        gender: null,
        ethnicity: null,
        address: null,
        zipcode: null,
        city: null,
        state: null,
        country: null,
        resume_url: null,
      },
      file_type: null,
      areSectionsLoading: false,
      STATIC_FIELD_TYPE,
      QUES_TYPES,
      sections: [],
      customSectionData: {},
      customSectionValidation: null,
      STD_REG_PAY_OPTIONS,
      reg_desc: null,
      PROGRAM_PAYMENT_OPTIONS,

      selectedSponsorship: null,
      sponsorshipOptions: [],
      showApplication: false,
      applicationRes: {},
      applicationSubmitted: false,
      showSuperadminSponsorshipAlert: false,
      bypassSuperadminSponsorshipAlertOnce: false,
      waiveAppFee: false,

      affId: null,
    };
  },
  validations() {
    const val = {
      registration_reason: {
        required: requiredIf(() => this.responseData.registration_reason === STATIC_FIELD_TYPE.REQUIRED),
      },
      signature: { required },
      ethnicity: {
        required: requiredIf(() => get(this.responseData, 'ethnicity') === STATIC_FIELD_TYPE.REQUIRED),
      },
      ethnicity_other: { required: requiredIf(() => this.ethnicity === 'other') },
      other_registration_reason: { required: requiredIf(() => this.registration_reason === 'other') },
      student: {
        birthday: { required },
        certified_before: { required },
        ged_or_diploma: { required },
        career_service_interest: { required },

        desired_work_type: {
          required: requiredIf(() => this.responseData.desired_work_type === STATIC_FIELD_TYPE.REQUIRED),
        },
        desired_work_time: {
          required: requiredIf(() => this.responseData.desired_work_time === STATIC_FIELD_TYPE.REQUIRED),
        },
        desired_work_day: {
          required: requiredIf(() => this.responseData.desired_work_day === STATIC_FIELD_TYPE.REQUIRED),
        },
        work_travel: { required: requiredIf(() => this.responseData.work_travel === STATIC_FIELD_TYPE.REQUIRED) },

        lang_preferences: {
          required: requiredIf(() => this.responseData.lang_preferences === STATIC_FIELD_TYPE.REQUIRED),
        },
        resume_url: { required: requiredIf(() => this.responseData.resume_url === STATIC_FIELD_TYPE.REQUIRED) },

        address: { required: requiredIf(() => this.responseData.address === STATIC_FIELD_TYPE.REQUIRED) },
        zipcode: { required: requiredIf(() => this.responseData.zipcode === STATIC_FIELD_TYPE.REQUIRED) },
        city: { required: requiredIf(() => this.responseData.city === STATIC_FIELD_TYPE.REQUIRED) },
        state: { required: requiredIf(() => this.responseData.state === STATIC_FIELD_TYPE.REQUIRED) },
        country: { required: requiredIf(() => this.responseData.country === STATIC_FIELD_TYPE.REQUIRED) },
        student_ssn: {
          required: requiredIf(() => this.responseData.student_ssn === STATIC_FIELD_TYPE.REQUIRED),
          length(value) {
            return this.responseData.student_ssn === STATIC_FIELD_TYPE.REQUIRED
              ? this.isFourDigitSSN
                ? value.length === 4
                : value.length === 9
              : true;
          },
          // isCorrectFormat: (value) => !value || SSN_FORMAT_REGEX.test(value),
        },

        occupation: { required: requiredIf(() => this.responseData.occupation === STATIC_FIELD_TYPE.REQUIRED) },
      },
      plan_to_pay: { required: requiredIf(() => this.responseData.plan_to_pay === STATIC_FIELD_TYPE.REQUIRED) },
      other_reference: { required: requiredIf(() => this.reference === 'other') },
      reference: { required: requiredIf(() => this.responseData.reference === STATIC_FIELD_TYPE.REQUIRED) },
      interested_facility_types: {
        required: requiredIf(() => this.responseData.interested_facility_types === STATIC_FIELD_TYPE.REQUIRED),
      },
      selectedSponsorship: { required: requiredIf(() => this.plan_to_pay === 'sponsored_employer_agency') },
      //other_interested_facility_types: { required: requiredIf(() => this.interested_facility_types.includes('other')) },
      payment_option: {
        required: requiredIf(
          () => get(this.classSch, 'program.tuition_reg_req') === false && this.plan_to_pay === 'self_pay'
        ),
      },
      class_plan_group: {
        // Only the self-pay + deposit path asks for a plan, and only a class offering
        // more than one is a real choice; a single plan is auto-selected, matching the
        // pre-multi-plan behaviour.
        required: requiredIf(
          () =>
            this.plan_to_pay === 'self_pay' &&
            this.payment_option === STD_REG_PAY_OPTIONS.PAY_LATER &&
            this.classPaymentPlans.length > 1
        ),
      },
      user: {
        firstName: { required },
        lastName: { required },
        email: { required, email },
        phone: {
          required,
          isCorrectFormat(value) {
            return PHONE_FORMAT_REGEX.test(value);
          },
        },
        avatarUrl: '',
        gender: { required: requiredIf(() => this.responseData.gender === STATIC_FIELD_TYPE.REQUIRED) },
      },
      customSectionData: {},
    };

    return val;
  },
  computed: {
    ...mapGetters('school', ['getCurrentSchool']),
    // An initiated registration locks the payment method and option, but the student
    // still chooses their own payment plan. Fade only what is locked -- putting opacity
    // on an ancestor would swallow the plan picker, which no descendant can undo.
    regLockedStyle() {
      return this.$route.query.regId ? 'opacity: 0.6;' : '';
    },
    // The class' installments arrive flat; rows sharing a plan_group are one plan the
    // student can pick. Each plan lists its installments in order so the shape of the
    // schedule -- how many payments, how far apart -- reads at a glance.
    classPaymentPlans() {
      const tuitionFee = get(this.classSch, 'program.tuition_fee', 0);
      const isScheduled = get(this.classSch, 'class_type') === CLASS_SCHEDULE_TYPES.SCHEDULED;

      const plans = get(this.classSch, 'payment_plan', []).reduce((acc, row) => {
        let plan = acc.find(p => p.plan_group === row.plan_group);
        if (!plan) {
          plan = {
            plan_group: row.plan_group,
            plan_title: row.plan_title || `Plan ${acc.length + 1}`,
            installments: [],
          };
          acc.push(plan);
        }

        const amount = Number(row.amount) || 0;
        const days = Number(row.days_after) || 0;

        plan.installments.push({
          ...row,
          displayAmount: row.amount_type === PAYMENT_TYPE.PERCENTAGE ? (amount / 100) * tuitionFee : amount,
          // Days from registration. Scheduled plans are measured from the earliest due
          // date the class offers, so the two class types sort the same way.
          offset: isScheduled ? 0 : days,
          primaryLabel: isScheduled
            ? row.date
              ? moment(row.date).format('MMM D, YYYY')
              : 'At signup'
            : days
            ? `Day ${days}`
            : 'At signup',
          secondaryLabel: isScheduled
            ? row.date
              ? moment(row.date).format('dddd')
              : ''
            : days
            ? `${days} ${days === 1 ? 'day' : 'days'} after registration`
            : 'Due on registration',
        });
        return acc;
      }, []);

      if (isScheduled) {
        const dates = plans
          .reduce((all, plan) => all.concat(plan.installments), [])
          .filter(inst => inst.date)
          .map(inst => moment(inst.date));
        const origin = dates.length ? moment.min(dates) : null;

        plans.forEach(plan =>
          plan.installments.forEach(inst => {
            inst.offset = origin && inst.date ? moment(inst.date).diff(origin, 'days') : 0;
          })
        );
      }

      plans.forEach(plan => {
        plan.installments.sort((a, b) => a.offset - b.offset);
        plan.total = plan.installments.reduce((sum, inst) => sum + inst.displayAmount, 0);

        const count = plan.installments.length;
        plan.spanLabel = `${count} payment${count === 1 ? '' : 's'} · ${this.$n(
          plan.total,
          'currency',
          'en-US'
        )}`;
      });

      return plans;
    },
    isFourDigitSSN() {
      return this.getCurrentSchool ? this.getCurrentSchool.is_four_digit_ssn : false;
    },
    isFormLoading() {
      return (
        this.isLoading ||
        this.isClassLoading ||
        this.isLogoUploading ||
        this.isDataLoading ||
        this.isPayLoading ||
        this.areProductsLoading ||
        Object.values(this.isUploading).some(val => val) ||
        Object.values(this.isQueFileUploading).some(val => val)
      );
    },

    fullClassLocation() {
      return get(this.classSch, 'class_location')
        ? `${this.classSch.class_location.address}, ${this.classSch.class_location.city}, ${this.classSch.class_location.state} ${this.classSch.class_location.zipcode}, ${this.classSch.class_location.country}`
        : 'N/A';
    },
    totalAmount() {
      return this.cartArr.reduce((total, item) => item.price * item.quantity + total, 0);
    },

    calcServiceFee() {
      // Healthcare Enroll Service Fee = 4% of total transaction fee.
      // Minimum service fee is $2.99

      const serviceFee =
        (this.calcPrgApplicationFee +
          (this.products.length !== 0 ? this.totalAmount : 0) +
          (this.payment_option === STD_REG_PAY_OPTIONS.PAY_NOW ? get(this.classSch, 'program.tuition_fee', 0) : 0)) *
        0.04;

      return serviceFee > STD_REG_MIN_SERVICE_FEE ? serviceFee : STD_REG_MIN_SERVICE_FEE;
    },
    calTotalFee() {
      if (this.payment_option === STD_REG_PAY_OPTIONS.PAY_NOW) {
        return (
          get(this.classSch, 'program.tuition_fee', 0) +
          this.calcPrgApplicationFee +
          (this.products.length !== 0 ? this.totalAmount : 0) +
          this.calcServiceFee
        );
      } else
        return this.calcServiceFee + (this.products.length !== 0 ? this.totalAmount : 0) + this.calcPrgApplicationFee;
    },
    totalTuition() {
      return get(this.classSch, 'program.tuition_fee', 0) + get(this.classSch, 'program.application_fee', 0);
    },

    // what 'Pay in Full Now' actually bills -- totalTuition is the program's
    // sticker price and ignores a waived application fee
    payNowDueToday() {
      return get(this.classSch, 'program.tuition_fee', 0) + this.calcPrgApplicationFee;
    },

    // the option is locked on an initiated registration, so say plainly what the
    // student is being asked to pay instead of leaving them to infer it
    initiatedPaymentSummary() {
      if (!this.$route.query.regId) return '';

      const money = value => this.$n(value, 'currency', 'en-US');
      const tuition = get(this.classSch, 'program.tuition_fee', 0);
      const appFee = get(this.classSch, 'program.application_fee', 0);
      const feeWaived = this.waiveAppFee && appFee > 0;

      if (this.payment_option === STD_REG_PAY_OPTIONS.PAY_NOW) {
        return feeWaived
          ? `Your school has waived the ${money(appFee)} application fee. You pay ${money(
              tuition
            )} today, plus the service fee.`
          : `You pay ${money(this.payNowDueToday)} today, plus the service fee.`;
      }

      if (this.payment_option === STD_REG_PAY_OPTIONS.PAY_LATER) {
        return feeWaived
          ? `Your school has already collected your deposit, so nothing is due today. Your ${money(
              tuition
            )} tuition will be billed through the class payment plan.`
          : `You pay the ${money(this.calcPrgApplicationFee)} deposit today. The remaining ${money(
              tuition
            )} tuition will be billed through the class payment plan.`;
      }

      return '';
    },

    calcPrgApplicationFee() {
      return this.payment_option === STD_REG_PAY_OPTIONS.FREE_PLAN || this.waiveAppFee
        ? 0
        : get(this.classSch, 'program.application_fee', 0);
    },

    enteredStdAddr() {
      const addr = [this.student.address, this.student.city, this.student.state, this.student.zipcode].filter(e => !!e);

      return addr.join(', ');
    },

    affiliateId() {
      return this.$route.query.affid || this.affId || null;
    },
    superadminSponsorshipCtaLink() {
      const linkCandidates = [
        get(this.selectedSponsorship, 'call_to_action'),
        get(this.selectedSponsorship, 'external_link'),
        get(this.selectedSponsorship, 'cta_link'),
        get(this.selectedSponsorship, 'cta_btn_link'),
        get(this.selectedSponsorship, 'callToAction'),
        get(this.selectedSponsorship, 'externalLink'),
      ];

      const ctaLink = linkCandidates.find(link => typeof link === 'string' && link.trim());
      return ctaLink ? ctaLink.trim() : null;
    },
  },
  watch: {
    classSch: {
      handler(value) {
        if (value && this.getCurrentSchool) {
          this.school = get(this.getCurrentSchool, 'id');
          this.fetchRegistrationForm();
        }
      },
    },
  },
  methods: {
    ...mapActions('student', [
      'getStudentUploadPresignedUrl',
      'createStudent',
      'createRegPaymentIntent',
      'registrationPaymentSuccess',
      'registrationPaymentFailed',
      'getInitiateReg',
    ]),
    ...mapActions('program', ['getAllScholarshipList']),
    ...mapActions('registrationForm', ['getPublicRegistrationForm']),
    ...mapActions('s3Upload', ['uploadToPresignedUrl']),
    ...mapActions('classes', ['getPublicClass']),
    ...mapActions('sections', ['getPublicSections']),
    ...mapActions('payoutAcc', ['intentPay']),
    ...mapActions('products', ['getPublicProducts']),
    ...mapActions('preEnrollForm', ['getPreEnrollFormObj']),
    formatDateSimple,
    formatFullDate,
    getClickableLink,
    stdPlanToPayOptions,
    changeField() {
      if (this.ssnPassType === 'text') {
        this.ssnPassType = 'password';
        this.visibility = false;
      } else {
        this.ssnPassType = 'text';
        this.visibility = true;
      }
    },

    get,
    setImage(file, image, uploadType = 'images') {
      this.selectedUploadFile[image] = file;
      this.uploadFile(image, uploadType);
    },
    goToHome() {
      this.$router.push({ name: 'home' });
    },
    async fetchPreEnrollForm() {
      this.isPreEnrollLoading = true;
      try {
        const resp = (await this.getPreEnrollFormObj(this.$route.query.pre_enrollment_id)).data;
        this.user.email = resp.email;
        this.user.firstName = resp.first_name;
        this.user.lastName = resp.last_name;
        this.user.phone = resp.phone;

        this.classIdFromPreEnroll = resp.class_enrolled.id;
        this.student.birthday = resp.payload;
        this.user.gender = resp.payload.gender;
        this.student.desired_work_type = resp.payload.desired_work_type;
        this.student.desired_work_time = resp.payload.desired_work_time;
        this.student.desired_work_day = resp.payload.desired_work_day;
        this.student.work_travel = resp.payload.work_travel;
        this.student.lang_preferences = resp.payload.lang_preferences;
        this.student.certified_before = resp.payload.certified_before;
        this.student.resume_url = resp.payload.resume_url;
        this.student.address = resp.payload.address;
        this.student.zipcode = resp.payload.zipcode;
        this.student.city = resp.payload.city;
        this.student.state = resp.payload.state;
        this.student.country = resp.payload.country;
        this.interested_facility_types = resp.payload.interested_facility_types;
        this.student.career_service_interest = resp.payload.career_service_interest;
        this.student.student_ssn = resp.payload.student_ssn;
        this.ethnicity = resp.payload.ethnicity;

        this.student.occupation = resp.payload.occupation;
      } catch (err) {
        this.makeToast({ variant: 'danger', msg: this.$t('generalMsgs.genErrorMsg') });
      }
      this.isPreEnrollLoading = false;
    },
    addToCart(obj, quantity, size, color) {
      let foundProductIndex = this.cartArr.findIndex(
        product => product.id === obj.id && product.size === size && product.color === color
      );
      if (foundProductIndex !== -1) {
        let newQuantity = this.cartArr[foundProductIndex].quantity + quantity;
        this.cartArr[foundProductIndex].quantity = newQuantity;
      } else {
        this.cartArr.push({ ...obj, quantity: quantity, size: size, color: color });
      }
    },
    removeFromCart(id) {
      let updatedArr = this.cartArr.filter(x => x.id !== id);
      this.cartArr = updatedArr;
    },
    incrementQuantity(index) {
      this.cartArr[index].quantity += 1;
    },
    decrementQuantity(index) {
      this.cartArr[index].quantity -= 1;
    },
    ApplicationFormResponse({ data, isSubmit }) {
      this.applicationRes = data;
      this.applicationSubmitted = isSubmit;
      if (this.applicationSubmitted && this.applicationRes) {
        this.showProductCard();
      } else {
        this.makeToast({ variant: 'danger', msg: this.$t('generalMsgs.genErrorMsg') });
      }
    },
    isBySuperadminSponsorshipSelected() {
      return (
        this.plan_to_pay === 'sponsored_employer_agency' &&
        this.selectedSponsorship &&
        this.selectedSponsorship.id !== 'other' &&
        this.selectedSponsorship.scholarship_type === 'by_superadmin'
      );
    },
    onSuperadminSponsorshipAlertHide() {
      this.bypassSuperadminSponsorshipAlertOnce = false;
    },
    continueRegistrationAfterSponsorshipAlert() {
      this.bypassSuperadminSponsorshipAlertOnce = true;
      this.showSuperadminSponsorshipAlert = false;
      this.showApplicationForm();
    },
    redirectToSuperadminSponsorshipCta() {
      const ctaLink = this.superadminSponsorshipCtaLink;

      if (ctaLink) {
        this.showSuperadminSponsorshipAlert = false;
        window.open(this.getClickableLink(ctaLink), '_blank');
      }
    },
    showApplicationForm() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.isBySuperadminSponsorshipSelected() && !this.bypassSuperadminSponsorshipAlertOnce) {
          this.showSuperadminSponsorshipAlert = true;
          return;
        }

        if (
          this.plan_to_pay === 'sponsored_employer_agency' &&
          this.selectedSponsorship &&
          this.selectedSponsorship.id != 'other' &&
          this.selectedSponsorship.scholarship_type === SPONSORSHIP_SUBMISSION_TYPES.IN_APP_SUBMISSION
        ) {
          this.showApplication = true;
        } else {
          this.showProductCard();
        }
      } else {
        this.makeToast({ variant: 'danger', msg: 'Please fill all fields correctly.' });
      }
    },
    showProductCard() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.products.length != 0) {
          this.showApplication = false;
          this.showProducts = true;
        } else this.onSubmit();
      } else {
        this.makeToast({ variant: 'danger', msg: 'Please fill all fields correctly.' });
      }
    },
    backFromProductInfo() {
      this.showProducts = false;
    },
    async pay() {
      if (
        (this.payment_option === STD_REG_PAY_OPTIONS.FREE_PLAN && !this.cartArr.length) ||
        (this.payment_option === STD_REG_PAY_OPTIONS.PAY_LATER && !this.cartArr.length && this.waiveAppFee) ||
        (this.payment_option === STD_REG_PAY_OPTIONS.PAY_LATER &&
          !this.cartArr.length &&
          !get(this.classSch, 'program.application_fee'))
      ) {
        window.location.href = `${window.location.origin}/registration?class=${this.classSch.id}&draft=${this.intentDraftId}&checkoutSuccess=1`;
      } else this.$refs.paymentRef.submit();
    },
    async fetchProducts() {
      this.areProductsLoading = true;

      const response = await this.getPublicProducts({ program_id: this.classSch.program.id });
      this.products = response.data;
      // this.products.forEach((product) => {
      //   product['quantity'] = 1;
      // });
      this.areProductsLoading = false;
    },
    async fetchScholarships(params = {}) {
      try {
        const response = await this.getAllScholarshipList({
          program_id: this.classSch.program.id,
          is_active: true,
          in_reg_form: true,
          ...params,
        });

        this.sponsorshipOptions = (response.data || []).map((item) => ({
          ...item,
          title:
            item.scholarship_type === 'by_superadmin' && item.id !== 'other'
              ? `${item.title} (External Sponsorship)`
              : item.title,
        }));
        this.sponsorshipOptions.push({
          title: 'Other',
          id: 'other',
        });
      } catch (err) {
        this.makeToast({ variant: 'danger', msg: this.$t('generalMsgs.genErrorMsg') });
      }
    },
    async fetchSections(params = {}) {
      this.areSectionsLoading = true;
      try {
        const res = await this.getPublicSections({
          section_enroll_type: 'enrollment',
          program: this.classSch.program.id,
          ...params,
        });

        const secData = {};
        const queSecUploadFile = {};
        const queFileUploading = {};

        for (const sectionObj of res.data) {
          const quesObj = sectionObj.sectionquestion_set.reduce((obj, item) => {
            if (item.question.type === QUES_TYPES.FILE_TYPE) {
              queSecUploadFile[`sec-${sectionObj.id}-que-${item.question.id}`] = null;
              queFileUploading[`sec-${sectionObj.id}-que-${item.question.id}`] = false;
            }

            return Object.assign(obj, {
              [`question-${item.question.id}`]: null,
            });
          }, {});
          secData[`section-${sectionObj.id}`] = quesObj;
        }

        this.selectedQueUploadFile = queSecUploadFile;
        this.isQueFileUploading = queFileUploading;

        this.customSectionData = secData;
        this.sections = res.data;
      } catch (err) {
        this.makeToast({ variant: 'danger', msg: this.$t('generalMsgs.genErrorMsg') });
      }
      this.areSectionsLoading = false;
    },
    async fetchRegistrationForm() {
      this.isDataLoading = true;
      try {
        const resp = (
          await this.getPublicRegistrationForm({
            params: {
              program: this.classSch.program.id,
              school: this.school,
              enrollment_type: 'enrollment',
            },
          })
        ).data;

        resp.forEach(obj => {
          this.responseData[obj.field_abbr] = obj.status;
        });
      } catch (err) {
        this.makeToast({ variant: 'danger', msg: this.$t('generalMsgs.genErrorMsg') });
      }
      this.isDataLoading = false;
    },
    async fetchClass() {
      this.isClassLoading = true;

      const response = await this.getPublicClass({
        class: this.$route.query.class || this.classIdFromInitiate || this.classIdFromPreEnroll,
      });
      this.classSch = response.data;

      // A class with a single plan needs no choice from the student.
      this.class_plan_group = this.classPaymentPlans.length === 1 ? this.classPaymentPlans[0].plan_group : null;

      if (!this.$route.query.regId) {
        if (this.classSch.program.allow_pymnt_option !== PROGRAM_PAYMENT_OPTIONS.TUITION_REQ) {
          if (this.classSch.program.allow_pymnt_option === PROGRAM_PAYMENT_OPTIONS.PAY_LATER) {
            this.payment_option = STD_REG_PAY_OPTIONS.PAY_LATER;
          } else {
            this.payment_option = STD_REG_PAY_OPTIONS.PAY_NOW;
          }
        }
      }

      if (get(this.getCurrentSchool, 'pp_registration_desc')) {
        this.reg_desc = this.getCurrentSchool.pp_registration_desc
          .replaceAll(
            '{{application_fee}}',
            this.$n(get(this.classSch, 'program.application_fee', 0), 'currency', 'en-US')
          )
          .replaceAll('{{tuition_fee}}', this.$n(get(this.classSch, 'program.tuition_fee', 0), 'currency', 'en-US'));
      }
      if (!get(this.classSch, 'program.application_fee')) {
        this.waiveAppFee = true;
      }
      this.isClassLoading = false;
    },
    backToForm() {
      this.showPaymentDetail = false;
      this.elementsOptions['clientSecret'] = '';
      this.isPaymentDetailsLoading = false;
      this.confirmParams['return_url'] = '';
      this.registrationPaymentFailed({ draft_id: this.intentDraftId });
    },
    async onSubmit() {
      this.isLoading = true;
      // this.$v.$touch();
      // if (!this.$v.$invalid) {

      try {
        const sectionsArr = [];
        Object.entries(this.customSectionData).map(section => {
          Object.entries(section[1]).map(question => {
            sectionsArr.push({
              section: parseInt(section[0].split('-')[1]),
              question: parseInt(question[0].split('-')[1]),
              response: { data: question[1] },
            });
          });
        });
        this.student.birthday = this.student.birthday ? formatToAPIDate(moment(this.student.birthday)) : null;
        this.payment_option = this.$route.query.regId
          ? this.payment_option
          : get(this.classSch, 'program.tuition_reg_req') === false
          ? this.payment_option
          : STD_REG_PAY_OPTIONS.PAY_NOW;

        // Resolve pathway context: query params first (deep-link case), then
        // the localStorage stash saved when the prospect landed from a pathways
        // marketing link (survives the new-tab "Register" hop).
        let pathwayCtx = {
          pathway: this.$route.query.pathway || '',
          uni_offered_programs: this.$route.query.uni_offered_programs || '',
          pathway_token: this.$route.query.pathway_token || '',
        };
        if (!pathwayCtx.pathway && !pathwayCtx.pathway_token) {
          const PATHWAY_CTX_TTL_MS = 24 * 60 * 60 * 1000; // 24h
          try {
            const stashed = JSON.parse(localStorage.getItem('pathway_enrollment_ctx') || '{}');
            const fresh = stashed.ts && Date.now() - stashed.ts < PATHWAY_CTX_TTL_MS;
            if (fresh) {
              pathwayCtx = { ...pathwayCtx, ...stashed };
            } else {
              // Expired or undated — discard so it can't attach to a later,
              // unrelated registration.
              localStorage.removeItem('pathway_enrollment_ctx');
            }
          } catch (e) {
            /* ignore absent/malformed stash */
          }
        }

        const data = {
          ...(this.selectedSponsorship &&
            this.selectedSponsorship.scholarship_type !== SPONSORSHIP_SUBMISSION_TYPES.IN_APP_SUBMISSION && {
              scholarship_name: this.selectedSponsorship.title,
            }),
          school: this.school,
          registration: {
            program: this.classSch.program.id,
            class_enrolled: this.classSch.id,
            plan_to_pay: this.plan_to_pay,
            registration_reason: this.registration_reason,
            ...(this.other_registration_reason && { other_registration_reason: this.other_registration_reason }),
            signature: this.signature,
            payment_option: this.payment_option,
          },
          reference: this.reference,
          ...(this.other_reference && { other_reference: this.other_reference }),
          ethnicity: this.ethnicity,
          ...(this.ethnicity_other && { ethnicity_other: this.ethnicity_other }),
          interested_facility_types: this.interested_facility_types,

          ...this.student,
          diploma_date: this.student.diploma_date ? formatToAPIDate(moment(this.student.diploma_date)) : null,
          products_bought: this.products.length > 0 ? this.cartArr : [],
          student_question_response: sectionsArr,
          user: {
            email: this.user.email,
            first_name: titleize(this.user.firstName),
            last_name: titleize(this.user.lastName),
            password: generator.generate({ length: 10, numbers: true, strict: true }),
            phone: this.user.phone,
            bio: this.user.bio,
            avatar_url: this.user.avatarUrl,
            gender: this.user.gender,
          },
          reg_id: this.$route.query.regId || null,
          pre_enrollment_id: this.$route.query.pre_enrollment_id || null,

          ...(this.plan_to_pay === 'self_pay' &&
            this.payment_option === STD_REG_PAY_OPTIONS.PAY_LATER &&
            this.class_plan_group && { class_plan_group: this.class_plan_group }),

          ...(pathwayCtx.pathway && {
            pathway_enrollment: {
              pathway_id: parseInt(pathwayCtx.pathway, 10),
              uni_offered_program_ids: (pathwayCtx.uni_offered_programs || '')
                .toString()
                .split(',')
                .map(s => parseInt(s, 10))
                .filter(n => !isNaN(n)),
              ...(pathwayCtx.pathway_token && { pathway_token: pathwayCtx.pathway_token }),
            },
          }),

          ...(this.applicationSubmitted && this.applicationRes),

          ...(this.affiliateId && { aff_id: this.affiliateId }),
        };

        // Adding payment intent related info for displaying payment element

        this.isPaymentDetailsLoading = true;

        const paymentIntent = await this.createRegPaymentIntent(data);

        this.intentDraftId = paymentIntent.draft_id;
        const draftId = paymentIntent.draft_id;
        if (paymentIntent.intent) {
          this.elementsOptions['clientSecret'] = paymentIntent.intent;

          this.confirmParams[
            'return_url'
          ] = `${window.location.origin}/registration?class=${this.classSch.id}&draft=${draftId}&checkoutSuccess=1`;
        }

        this.showRefundPolicy = true;
      } catch (err) {
        // The backend names the exact reason (class closed, class full, already
        // registered); show it verbatim and fall back only when it says nothing.
        this.makeToast({
          variant: 'danger',
          msg:
            get(err, 'response.data.message') || 'Cannot register you in this class. Please contact administrator.',
          autoHideDelay: 5000,
        });
        this.isPaymentDetailsLoading = false;
        captureException(err);
      }
      // } else {
      //   this.makeToast({ variant: 'danger', msg: 'Please fill all fields correctly.' });
      // }
      this.isLoading = false;
    },

    acceptRefund() {
      if (this.acceptRefundPolicy) {
        this.showPaymentDetail = true;
        this.showRefundPolicy = false;
      }
    },

    async uploadFile(
      fileType,
      uploadType = 'documents',
      profileUrlField = 'resume_url',
      section = null,
      question = null
    ) {
      let file;

      if (fileType === QUES_TYPES.FILE_TYPE) {
        this.uploadCancelTokenSource[fileType][`sec-${section}-que-${question}`] = axios.CancelToken.source();
        this.isQueFileUploading[`sec-${section}-que-${question}`] = true;
        file = this.selectedQueUploadFile[`sec-${section}-que-${question}`];
      } else {
        this.uploadCancelTokenSource[fileType] = axios.CancelToken.source();
        this.isUploading[fileType] = true;
        file = this.selectedUploadFile[fileType];
      }

      try {
        const urlResp = await this.getStudentUploadPresignedUrl({
          file_name: file.name,
          content_type: file.type,
          upload_type: uploadType,
        });

        await this.uploadToPresignedUrl({
          url: urlResp.upload_url,
          file: file,
          config: {
            onUploadProgress: function(progressEvent) {
              const percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              if (fileType === QUES_TYPES.FILE_TYPE) {
                this.uploadPercent[fileType][`sec-${section}-que-${question}`] = percentage;
              } else {
                this.uploadPercent[fileType] = percentage;
              }
            }.bind(this),
            cancelToken: this.uploadCancelTokenSource[fileType].token,
          },
        });
        if (fileType === 'avatar') {
          this.user.avatarUrl = urlResp.upload_url.split('?')[0];
        } else if (fileType === 'file_type') {
          this.customSectionData[`section-${section}`][`question-${question}`] = urlResp.upload_url.split('?')[0];
          this.file_type = urlResp.upload_url.split('?')[0];
        } else this.student[profileUrlField] = urlResp.upload_url.split('?')[0];
      } catch (error) {
        if (fileType === QUES_TYPES.FILE_TYPE) {
          this.selectedQueUploadFile[`sec-${section}-que-${question}`] = null;
        } else {
          this.selectedUploadFile[fileType] = null;
        }
      }
      if (fileType === QUES_TYPES.FILE_TYPE) {
        this.uploadCancelTokenSource[fileType][`sec-${section}-que-${question}`] = null;
        this.uploadPercent[fileType][`sec-${section}-que-${question}`] = 0;
        this.isQueFileUploading[`sec-${section}-que-${question}`] = false;
      } else {
        this.uploadCancelTokenSource[fileType] = null;
        this.uploadPercent[fileType] = 0;
        this.isUploading[fileType] = false;
      }
    },
    fillInOptions() {
      var usStates = new UsaStates();
      this.stateOptions = this.stateOptions.concat(
        map(usStates.states, state => ({
          value: state.name,
          text: state.name,
        }))
      );
      this.countryOptions = this.countryOptions.concat(
        map(countries, country => ({
          value: country.name,
          text: country.name,
        }))
      );

      this.workDayOptions = map(moment.weekdays(), day => ({ value: day.toLowerCase(), text: day }));

      this.workTravelOptions = getWorkTravelOptions();

      this.langOptions = getLangOptions();
    },
    async fetchInitiateDraft() {
      this.isClassLoading = true;

      try {
        const response = await this.getInitiateReg({ regId: this.$route.query.regId });

        this.user.email = response.data.user.email;
        this.user.firstName = response.data.user.first_name;
        this.user.lastName = response.data.user.last_name;
        this.user.phone = response.data.user.phone;
        this.user.gender = response.data.user.gender;

        this.payment_option = response.data.registration.payment_option;
        this.waiveAppFee = response.data.waive_app_fee;
        this.classIdFromInitiate = response.data.registration.class_enrolled;
        this.student.birthday = response.data.birthday;
      } catch (err) {
        this.goToHome();
      }

      this.isClassLoading = false;
    },
  },
  async created() {
    this.fillInOptions();

    if (this.$route.query.checkoutSuccess) {
      this.isClassLoading = true;
      const draftId = this.$route.query.draft;
      try {
        await this.registrationPaymentSuccess({ draft_id: draftId });
        this.registeredSuccessfull = true;
        // Pathway context consumed — clear the stash so it can't attach to a
        // later, unrelated enrollment from the same browser.
        try {
          localStorage.removeItem('pathway_enrollment_ctx');
        } catch (e) {
          /* noop */
        }
        this.$router.push({ name: 'class-registration', query: { class: this.classSch.id, success: true } });
      } catch (err) {
        await this.registrationPaymentFailed({ draft_id: draftId });
        this.registeredUnsuccessfull = true;
        this.$router.push({ name: 'class-registration', query: { class: this.classSch.id, failed: true } });
        // this.makeToast({ variant: 'danger', msg: this.$t('generalMsgs.genErrorMsg') });
      }
      this.isClassLoading = false;
    } else {
      if (this.$route.query.regId) {
        await this.fetchInitiateDraft();
      }
      if (this.$route.query.pre_enrollment_id) {
        await this.fetchPreEnrollForm();
      }
      await this.fetchClass();
      this.fetchSections();
      this.fetchProducts();
      this.fetchScholarships();
    }
  },
};
</script>

<style>
.payment-method-icon {
  color: var(--secondary-color) !important;
}

.sponsorship-alert-modal .modal-dialog {
  max-width: 520px;
}

.sponsorship-alert-modal {
  --sponsorship-warning-color: #a05912;
  --sponsorship-warning-border-color: #f0c18c;
  --sponsorship-warning-bg-color: #fff5ea;
}

.sponsorship-alert-modal-content {
  border: 0;
  border-radius: 16px;
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.16);
}

.sponsorship-alert-modal-body {
  padding: 22px 22px 20px;
  position: relative;
}

.sponsorship-alert-close {
  border: 0;
  background: #eceff5;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  color: #7c8598;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 14px;
  top: 12px;
  cursor: pointer;
}

.sponsorship-alert-close:hover {
  background: #e1e6ef;
}

.sponsorship-alert-close .material-icons {
  font-size: 18px;
  color: var(--sponsorship-warning-color);
}

.sponsorship-alert-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.sponsorship-alert-icon-wrap {
  width: 44px;
  height: 44px;
  background: var(--sponsorship-warning-bg-color);
  border: 1px solid var(--sponsorship-warning-border-color);
  border-radius: 11px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.sponsorship-alert-icon-wrap .material-icons {
  color: var(--sponsorship-warning-color);
  font-size: 24px;
}

.sponsorship-alert-title {
  color: #1f2937;
  font-weight: 800;
  font-size: 22px;
  margin: 0;
}

.sponsorship-alert-text {
  font-size: 17px;
  color: #4b5563;
  line-height: 1.45;
}

.sponsorship-alert-warning-box {
  margin-top: 12px;
  margin-bottom: 16px;
  padding: 10px 12px;
  border: 1px solid var(--sponsorship-warning-border-color);
  border-radius: 9px;
  background: var(--sponsorship-warning-bg-color);
  color: var(--sponsorship-warning-color);
  font-size: 12px;
  line-height: 1.45;
  display: flex;
  align-items: flex-start;
  gap: 7px;
}

.sponsorship-alert-warning-box span {
  flex: 1;
  display: inline-block;
}

.sponsorship-alert-warning-box .material-icons {
  color: var(--sponsorship-warning-color);
  font-size: 16px;
  margin-top: 1px;
}

.sponsorship-alert-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 9px;
}

.sponsorship-alert-actions-single {
  grid-template-columns: 1fr;
}

.sponsorship-alert-btn {
  border-radius: 11px;
  font-weight: 700;
  font-size: 14px;
  min-width: 0;
  width: 100%;
  min-height: 42px;
  padding: 8px 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  line-height: 1;
}

.sponsorship-alert-btn-outline {
  border: 1px solid var(--primary-color, #41a9d6);
  color: var(--primary-color, #41a9d6);
  background: #fff;
}

.sponsorship-alert-btn-outline:hover,
.sponsorship-alert-btn-outline:focus,
.sponsorship-alert-btn-outline:active {
  border-color: var(--primary-color, #41a9d6) !important;
  color: var(--primary-color, #41a9d6) !important;
  background: rgba(65, 169, 214, 0.08) !important;
}

.sponsorship-alert-btn-primary {
  border: 1px solid var(--primary-color, #41a9d6);
  color: #fff;
  background: var(--primary-color, #41a9d6);
  box-shadow: 0 6px 14px rgba(65, 169, 214, 0.28);
}

.sponsorship-alert-btn-primary:hover,
.sponsorship-alert-btn-primary:focus,
.sponsorship-alert-btn-primary:active {
  color: #fff !important;
  border-color: var(--primary-color, #41a9d6) !important;
  background: var(--primary-color, #41a9d6) !important;
  filter: brightness(0.96);
}

@media (max-width: 576px) {
  .sponsorship-alert-modal-body {
    padding: 20px 16px 16px;
  }

  .sponsorship-alert-title {
    font-size: 20px;
  }

  .sponsorship-alert-text {
    font-size: 16px;
  }

  .sponsorship-alert-actions {
    flex-direction: row;
  }

  .sponsorship-alert-btn {
    min-width: auto;
    flex: 1;
    padding: 8px 10px;
  }
}
</style>

<style lang="scss" scoped>
/* The school's own primary colour drives the timeline; --primary-color is set on
   :root from the school record when the public site loads. */
.plan-picker__heading {
  font-size: 0.8125rem;
  font-weight: 600;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: #6c757d;
  margin-bottom: 0.75rem;
}

/* Two plans side by side where the form is wide enough to hold them, stacked where it
   is not. The timeline needs real width to keep its amount labels apart, so the
   breakpoint is set by the rail rather than by a screen size. */
.plan-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(18rem, 1fr));
  gap: 0.75rem;
  align-items: stretch;
}

.plan-option {
  display: flex;
  flex-direction: column;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  padding: 1rem 1.25rem 0.5rem;
  margin-bottom: 0.75rem;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    border-color: #c9cfd6;
  }

  &--selected {
    border-color: var(--primary-color, #3b86f5);
    box-shadow: 0 2px 14px -8px rgba(0, 0, 0, 0.35);
  }

  &__head {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 0.35rem 1rem;
  }

  &__radio {
    flex: 1 1 auto;
    min-width: 0;
  }

  &__name {
    font-size: 1.0625rem;
    font-weight: 700;
    margin-right: 0.6rem;
  }

  &__span {
    color: #6c757d;
    font-size: 0.9375rem;
  }
}

/* Installments read as a vertical timeline: a numbered stop per payment, joined by a
   connector. It stacks happily inside a narrow column, where a horizontal rail would
   have to scroll to keep its amount labels apart. */
.installments {
  list-style: none;
  /* Starts directly under the header -- a plan with fewer installments leaves its
     slack at the bottom of the card, not as a gap above the first payment. */
  margin: 0;
  padding: 0.25rem 0 0;
}

.installment {
  position: relative;
  display: grid;
  grid-template-columns: 1.5rem minmax(0, 1fr) auto;
  align-items: center;
  gap: 0 0.75rem;
  padding: 0.5rem 0.25rem;

  &:not(:last-child)::before {
    content: '';
    position: absolute;
    left: 0.9375rem;
    top: 2.1rem;
    bottom: -0.3rem;
    width: 2px;
    background: #e5e7eb;
  }

  &__marker {
    position: relative;
    z-index: 1;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    border: 2px solid var(--primary-color, #3b86f5);
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75rem;
    font-weight: 700;
    color: #6c757d;
    font-variant-numeric: tabular-nums;
  }

  &__when {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  &__primary {
    font-weight: 600;
    color: #131920;
    line-height: 1.3;
  }

  &__secondary {
    font-size: 0.8125rem;
    color: #868e96;
    line-height: 1.3;
  }

  &__money {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    text-align: right;
    white-space: nowrap;
  }

  &__amount {
    font-weight: 700;
    color: #131920;
    line-height: 1.3;
    font-variant-numeric: tabular-nums;
  }

  &__share {
    font-size: 0.8125rem;
    color: #868e96;
    line-height: 1.3;
    font-variant-numeric: tabular-nums;
  }
}
</style>
